/* eslint-disable @typescript-eslint/ban-ts-ignore */

import axios from 'axios'
import { EventSourcePolyfill, NativeEventSource } from 'event-source-polyfill'
import playback from '@bt-react/libs/playback'
import communities from '@bt-react/libs/communities'
import webcastServices from '@bt-react/libs/webcast'
import has from 'lodash/has'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { GenChannelReportReqData, SubscribersListTypes, GenAttendeeListReportReqData, GenActivityLogReportReqData } from './types'
import { ServiceError } from '@bt-react/constants'
import { debug } from '@bt-react/libs/Logger'
import getEmailType from '@bt-react/libs/getEmailType'
import channel from 'libs/libs/src/lib/channel'
import AssetUploadLocation from '@bt-react/libs/AssetUploadLocation'
import virtualEventServices from '@bt-react/libs/virtualEvent'
import download from '@bt-react/libs/download'

const btoa = require("btoa");

let BTUploader
if (typeof document !== 'undefined') {
  BTUploader = require('brighttalk-uploader').default
}

const EventSource = NativeEventSource || EventSourcePolyfill
// @ts-ignore
global.EventSource = NativeEventSource || EventSourcePolyfill

export const actionTypes = {

  SET_HOST: 'SET_HOST',
  FETCH_TIMEZONES: 'FETCH_TIMEZONES',
  FETCH_TIMEZONES_SUCCESS: 'FETCH_TIMEZONES_SUCCESS',
  FETCH_TIMEZONES_ERROR: 'FETCH_TIMEZONES_ERROR',
  FETCH_CHANNEL_DATA: 'FETCH_CHANNEL_DATA',
  FETCH_CHANNEL_DATA_SUCCESS: 'FETCH_CHANNEL_DATA_SUCCESS',
  FETCH_CHANNEL_DATA_ERROR: 'FETCH_CHANNEL_DATA_ERROR',
  FETCH_WEBCAST_DATA: 'FETCH_WEBCAST_DATA',
  FETCH_WEBCAST_DATA_SUCCESS: 'FETCH_WEBCAST_DATA_SUCCESS',
  FETCH_WEBCAST_DATA_ERROR: 'FETCH_WEBCAST_DATA_ERROR',
  FETCH_WEBCAST_DATA_FORBIDDEN: 'FETCH_WEBCAST_DATA_FORBIDDEN',
  FETCH_PUBLIC_WEBCAST_DATA: 'FETCH_PUBLIC_WEBCAST_DATA',
  FETCH_PUBLIC_WEBCAST_DATA_SUCCESS: 'FETCH_PUBLIC_WEBCAST_DATA_SUCCESS',
  FETCH_PUBLIC_WEBCAST_DATA_ERROR: 'FETCH_PUBLIC_WEBCAST_DATA_ERROR',
  FETCH_PLAYBACK_DATA: 'FETCH_PLAYBACK_DATA',
  FETCH_PLAYBACK_DATA_SUCCESS: 'FETCH_PLAYBACK_DATA_SUCCESS',
  FETCH_PLAYBACK_DATA_ERROR: 'FETCH_PLAYBACK_DATA_ERROR',
  FEATURE_IMAGE_PROCESSING: 'FEATURE_IMAGE_PROCESSING',
  FEATURE_IMAGE_COMPLETED: 'FEATURE_IMAGE_COMPLETED',
  FEATURE_IMAGE_NOT_FOUND: 'FEATURE_IMAGE_NOT_FOUND',
  FEATURE_IMAGE_CLEAR_LOOP_CHECK: 'FEATURE_IMAGE_CLEAR_LOOP_CHECK',
  FEATURE_IMAGE_REQUESTING_STATUS: 'FEATURE_IMAGE_REQUESTING_STATUS',
  FEATURE_IMAGE_READY: 'FEATURE_IMAGE_READY',
  FEATURE_IMAGE_FAILED: 'FEATURE_IMAGE_FAILED',
  SELECT_FEATURE_IMAGE_UPLOAD_SUCCESS: 'SELECT_FEATURE_IMAGE_UPLOAD_SUCCESS',
  SELECT_FEATURE_IMAGE_UPLOAD_FAILED: 'SELECT_FEATURE_IMAGE_UPLOAD_FAILED',
  POST_BASIC_TEMPLATE_CREATION_SUCCESS: 'POST_BASIC_TEMPLATE_CREATION_SUCCESS',
  POST_BASIC_TEMPLATE_CREATION_FAILED: 'POST_BASIC_TEMPLATE_CREATION_FAILED',
  SUBMITING_COMMUNITIES: 'SUBMITING_COMMUNITIES',
  SUBMITING_COMMUNITIES_SUCCESS: 'SUBMITING_COMMUNITIES_SUCCESS',
  FETCHING_COMMUNITIES: 'FETCHING_COMMUNITIES',
  FETCHING_COMMUNITIES_SUCCESS: 'FETCHING_COMMUNITIES_SUCCESS',
  FETCHING_COMMUNITIES_CHANNEL_FAILED: 'FETCHING_COMMUNITIES_CHANNEL_FAILED',
  FETCHING_COMMUNITIES_WEBCAST_FAILED: 'FETCHING_COMMUNITIES_WEBCAST_FAILED',
  SUBMIT_WEBCAST: 'SUBMIT_WEBCAST',
  SUBMIT_WEBCAST_SUCCESS: 'SUBMIT_WEBCAST_SUCCESS',
  SUBMIT_WEBCAST_SUCCESS_EDIT: 'SUBMIT_WEBCAST_SUCCESS_EDIT',
  SUBMIT_WEBCAST_ERROR: 'SUBMIT_WEBCAST_ERROR',
  CLEAR_SERVER_ERROR: 'CLEAR_SERVER_ERROR',
  POST_WEBCAST_CREATION: 'POST_WEBCAST_CREATION',
  POST_WEBCAST_CREATION_SUCCESS: 'POST_WEBCAST_CREATION_SUCCESS',
  POST_BASIC_TEMPLATE_CREATION: 'POST_BASIC_TEMPLATE_CREATION',
  POST_BASIC_TEMPLATE_SUCCESS: 'POST_BASIC_TEMPLATE_SUCCESS',
  FETCH_COMMUNICATIONS: 'FETCH_COMMUNICATIONS',
  FETCH_COMMUNICATIONS_SUCCESS: 'FETCH_COMMUNICATIONS_SUCCESS',
  FETCH_COMMUNICATIONS_FAILED: 'FETCH_COMMUNICATIONS_FAILED',
  RESET_CREATION: 'RESET_CREATION',
  PUT_ACTIVITY: 'PUT_ACTIVITY',
  PUT_ACTIVITY_SUCCESS: 'PUT_ACTIVITY_SUCCESS',
  PUT_ACTIVITY_FAILED: 'PUT_ACTIVITY_FAILED',
  FETCH_ACTIVITY: 'FETCH_ACTIVITY',
  FETCH_ACTIVITY_SUCCESS: 'FETCH_ACTIVITY_SUCCESS',
  FETCH_ACTIVITY_FAILED: 'FETCH_ACTIVITY_FAILED',
  GENERATE_CHANNEL_REPORT: 'GENERATE_CHANNEL_REPORT',
  CHANNEL_REPORT_GENERATION_STARTED: 'CHANNEL_REPORT_GENERATION_STARTED',
  CHANNEL_REPORT_GENERATED_FAILED: 'CHANNEL_REPORT_GENERATED_FAILED',
  FETCH_CHANNEL_REPORT_STATUS: 'FETCH_CHANNEL_REPORT_STATUS',
  FETCH_CHANNEL_REPORT_SUCCESSFUL: 'FETCH_CHANNEL_REPORT_SUCCESSFUL',
  FETCH_CHANNEL_REPORT_FAILED: 'FETCH_CHANNEL_REPORT_FAILED',
  CANCEL_FETCH_CHANNEL_REPORT_STATUS: 'CANCEL_FETCH_CHANNEL_REPORT_STATUS',
  FETCH_CHANNEL_REPORT_STATUS_CANCELLED: 'FETCH_CHANNEL_REPORT_STATUS_CANCELLED',
  CANCEL_FETCH_CHANNEL_REPORT_STATUS_FAILED: 'CANCEL_FETCH_CHANNEL_REPORT_STATUS_FAILED',
  FETCH_SYNDICATION_DETAILS: 'FETCH_SYNDICATION_DETAILS',
  SYNDICATION_DETAILS_FETCHED_SUCCESSFULLY: 'SYNDICATION_DETAILS_FETCHED_SUCCESSFULLY',
  SYNDICATION_DETAILS_FETCH_FAILED: 'SYNDICATION_DETAILS_FETCH_FAILED',
  FETCH_ALL_ACTIVITIES: 'FETCH_ALL_ACTIVITIES',
  FETCH_ALL_ACTIVITIES_SUCCESSFUL: 'FETCH_ALL_ACTIVITIES_SUCCESSFUL',
  FETCH_ALL_ACTIVITIES_FAILED: 'FETCH_ALL_ACTIVITIES_FAILED',
  FETCH_ACCOUNT_NAME: 'FETCH_ACCOUNT_NAME',
  FETCH_ACCOUNT_NAME_SUCCESSFUL: 'FETCH_ACCOUNT_NAME_SUCCESSFUL',
  FETCH_ACCOUNT_NAME_FAILED: 'FETCH_ACCOUNT_NAME_FAILED',
  FETCH_AUDIENCE_SUMMARY: 'FETCH_AUDIENCE_SUMMARY',
  FETCH_AUDIENCE_SUMMARY_SUCCESSFUL: 'FETCH_AUDIENCE_SUMMARY_SUCCESSFUL',
  FETCH_AUDIENCE_SUMMARY_FAILED: 'FETCH_AUDIENCE_SUMMARY_FAILED',
  FETCH_QUESTIONS_COUNT: 'FETCH_QUESTIONS_COUNT',
  FETCH_QUESTIONS_COUNT_SUCCESSFUL: 'FETCH_QUESTIONS_COUNT_SUCCESSFUL',
  FETCH_QUESTIONS_COUNT_FAILED: 'FETCH_QUESTIONS_COUNT_FAILED',
  FETCH_FEEDBACK_SUMMARY: 'FETCH_FEEDBACK_SUMMARY',
  FETCH_FEEDBACK_SUMMARY_SUCCESSFUL: 'FETCH_FEEDBACK_SUMMARY_SUCCESSFUL',
  FETCH_FEEDBACK_SUMMARY_FAILED: 'FETCH_FEEDBACK_SUMMARY_FAILED',
  FETCH_AUDIENCE_CHART: 'FETCH_AUDIENCE_CHART',
  FETCH_AUDIENCE_CHART_SUCCESSFUL: 'FETCH_AUDIENCE_CHART_SUCCESSFUL',
  FETCH_AUDIENCE_CHART_FAILED: 'FETCH_AUDIENCE_CHART_FAILED',
  FETCH_SUBSCRIBER_GROWTH_CHART: 'FETCH_SUBSCRIBER_GROWTH_CHART',
  FETCH_SUBSCRIBER_GROWTH_CHART_SUCCESSFUL: 'FETCH_SUBSCRIBER_GROWTH_CHART_SUCCESSFUL',
  FETCH_SUBSCRIBER_GROWTH_CHART_FAILED: 'FETCH_SUBSCRIBER_GROWTH_CHART_FAILED',
  FETCH_LIVE_VIEWERS: 'FETCH_LIVE_VIEWERS',
  FETCH_LIVE_VIEWERS_SUCCESSFUL: 'FETCH_LIVE_VIEWERS_SUCCESSFUL',
  FETCH_LIVE_VIEWERS_FAILED: 'FETCH_LIVE_VIEWERS_FAILED',
  FETCH_AUDIENCE_VIEWING_CHART: 'FETCH_AUDIENCE_VIEWING_CHART',
  FETCH_AUDIENCE_VIEWING_CHART_SUCCESSFUL: 'FETCH_AUDIENCE_VIEWING_CHART_SUCCESSFUL',
  FETCH_AUDIENCE_VIEWING_CHART_FAILED: 'FETCH_AUDIENCE_VIEWING_CHART_FAILED',
  CANCEL_WEBCAST: 'CANCEL_WEBCAST',
  CANCEL_WEBCAST_SUCCESS: 'CANCEL_WEBCAST_SUCCESS',
  CANCEL_WEBCAST_ERROR: 'CANCEL_WEBCAST_ERROR',
  REMOVE_SYNDICATION: 'REMOVE_SYNDICATION',
  REMOVE_SYNDICATION_SUCCESS: 'REMOVE_SYNDICATION_SUCCESS',
  REMOVE_SYNDICATION_FAILED: 'REMOVE_SYNDICATION_FAILED',
  FETCH_ONDEMAND_VIEWERS: 'FETCH_ONDEMAND_VIEWERS',
  FETCH_ONDEMAND_VIEWERS_SUCCESSFUL: 'FETCH_ONDEMAND_VIEWERS_SUCCESSFUL',
  FETCH_ONDEMAND_VIEWERS_FAILED: 'FETCH_ONDEMAND_VIEWERS_FAILED',
  FETCH_AUDIENCE_GROWTH_CHART: 'FETCH_AUDIENCE_GROWTH_CHART',
  FETCH_AUDIENCE_GROWTH_CHART_SUCCESSFUL: 'FETCH_AUDIENCE_GROWTH_CHART_SUCCESSFUL',
  FETCH_AUDIENCE_GROWTH_CHART_FAILED: 'FETCH_AUDIENCE_GROWTH_CHART_FAILED',
  FETCH_SYNDICATION: 'FETCH_SYNDICATION',
  FETCH_SYNDICATION_SUCCESS: 'FETCH_SYNDICATION_SUCCESS',
  FETCH_SYNDICATION_FAILED: 'FETCH_SYNDICATION_FAILED',
  APPROVE_SYNDICATION: 'APPROVE_SYNDICATION',
  APPROVE_SYNDICATION_SUCCESS: 'APPROVE_SYNDICATION_SUCCESS',
  APPROVE_SYNDICATION_FAILED: 'APPROVE_SYNDICATION_FAILED',
  CREATE_SYNDICATION: 'CREATE_SYNDICATION',
  CREATE_SYNDICATION_SUCCESS: 'CREATE_SYNDICATION_SUCCESS',
  CREATE_SYNDICATION_FAILED: 'CREATE_SYNDICATION_FAILED',
  FETCH_SUBSCRIBER_LIST: 'FETCH_SUBSCRIBER_LIST',
  FETCH_SUBSCRIBER_LIST_SUCCESSFUL: 'FETCH_SUBSCRIBER_LIST_SUCCESSFUL',
  FETCH_SUBSCRIBER_LIST_FAILED: 'FETCH_SUBSCRIBER_LIST_FAILED',
  FETCH_CONTENT_PERFORMANCE_CHART: 'FETCH_CONTENT_PERFORMANCE_CHART',
  FETCH_CONTENT_PERFORMANCE_CHART_SUCCESSFUL: 'FETCH_CONTENT_PERFORMANCE_CHART_SUCCESSFUL',
  FETCH_CONTENT_PERFORMANCE_CHART_FAILED: 'FETCH_CONTENT_PERFORMANCE_CHART_FAILED',
  FETCH_NURTURE_ANALYTICS: 'FETCH_NURTURE_ANALYTICS',
  FETCH_NURTURE_ANALYTICS_SUCCESSFUL: 'FETCH_NURTURE_ANALYTICS_SUCCESSFUL',
  FETCH_NURTURE_ANALYTICS_FAILED: 'FETCH_NURTURE_ANALYTICS_FAILED',
  DOWNLOAD_NURTURE_REPORT: 'DOWNLOAD_NURTURE_REPORT',
  DOWNLOAD_NURTURE_REPORT_SUCCESSFUL: 'DOWNLOAD_NURTURE_REPORT_SUCCESSFUL',
  DOWNLOAD_NURTURE_REPORT_FAILED: 'DOWNLOAD_NURTURE_REPORT_FAILED',
  FETCH_QUESTIONS_LIST: 'FETCH_QUESTIONS_LIST',
  FETCH_QUESTIONS_LIST_SUCCESSFUL: 'FETCH_QUESTIONS_LIST_SUCCESSFUL',
  FETCH_QUESTIONS_LIST_FAILED: 'FETCH_QUESTIONS_LIST_FAILED',
  FETCH_ATTACHMENT_DOWNLOAD_COUNT: 'FETCH_ATTACHMENT_DOWNLOAD_COUNT',
  FETCH_ATTACHMENT_DOWNLOAD_COUNT_SUCCESSFUL: 'FETCH_ATTACHMENT_DOWNLOAD_COUNT_SUCCESSFUL',
  FETCH_ATTACHMENT_DOWNLOAD_COUNT_FAILED: 'FETCH_ATTACHMENT_DOWNLOAD_COUNT_FAILED',
  FETCH_ATTACHMENTS: 'FETCH_ATTACHMENTS',
  FETCH_ATTACHMENTS_SUCCESSFUL: 'FETCH_ATTACHMENTS_SUCCESSFUL',
  FETCH_ATTACHMENTS_FAILED: 'FETCH_ATTACHMENTS_FAILED',
  FETCH_VOTES_COUNT: 'FETCH_VOTES_COUNT',
  FETCH_VOTES_COUNT_SUCCESSFUL: 'FETCH_VOTES_COUNT_SUCCESSFUL',
  FETCH_VOTES_COUNT_FAILED: 'FETCH_VOTES_COUNT_FAILED',
  FETCH_VOTES_LIST: 'FETCH_VOTES_LIST',
  FETCH_VOTES_LIST_SUCCESSFUL: 'FETCH_VOTES_LIST_SUCCESSFUL',
  FETCH_VOTES_LIST_FAILED: 'FETCH_VOTES_LIST_FAILED',
  FETCH_FEEDBACK_DATA: 'FETCH_FEEDBACK_DATA',
  FETCH_FEEDBACK_DATA_SUCCESSFUL: 'FETCH_FEEDBACK_DATA_SUCCESSFUL',
  FETCH_FEEDBACK_DATA_FAILED: 'FETCH_FEEDBACK_DATA_FAILED',
  REUPLOAD_VIDEO: 'REUPLOAD_VIDEO',
  VIDEO_UPLOAD_SUCCESS: 'VIDEO_UPLOAD_SUCCESS',
  VIDEO_UPLOADING_STATE: 'VIDEO_UPLOADING_STATE',
  VIDEO_PROCESSING_STATE: 'VIDEO_PROCESSING_STATE',
  VIDEO_PROCESS_SUCCESS: 'VIDEO_PROCESS_SUCCESS',
  VIDEO_UPLOAD_FAILED: 'VIDEO_UPLOAD_FAILED',
  ADD_UPLOADER: 'ADD_UPLOADER',
  SAVE_STATUS_INTERVAL: 'SAVE_STATUS_INTERVAL',
  VIDEO_UPLOAD_CANCELLED: 'VIDEO_UPLOAD_CANCELLED',
  FETCH_PLAYBACK_STATUS: 'FETCH_PLAYBACK_STATUS',
  FETCH_PLAYBACK_STATUS_SUCCESS: 'FETCH_PLAYBACK_STATUS_SUCCESS',
  FETCH_PLAYBACK_STATUS_ERROR: 'FETCH_PLAYBACK_STATUS_ERROR',
  VIDEO_TRANSCODING_STATE: 'VIDEO_TRANSCODING_STATE',
  UPDATE_WEBCAST_STATUS: 'UPDATE_WEBCAST_STATUS',
  FETCH_CHANNEL_FEATURE: 'FETCH_CHANNEL_FEATURE',
  FETCH_CHANNEL_FEATURE_SUCCESSFUL: 'FETCH_CHANNEL_FEATURE_SUCCESSFUL',
  FETCH_CHANNEL_FEATURE_FAILED: 'FETCH_CHANNEL_FEATURE_FAILED',
  UPDATE_CHANNEL_FEATURE: 'UPDATE_CHANNEL_FEATURE',
  UPDATE_CHANNEL_FEATURE_SUCCESSFUL: 'UPDATE_CHANNEL_FEATURE_SUCCESSFUL',
  UPDATE_CHANNEL_FEATURE_FAILED: 'UPDATE_CHANNEL_FEATURE_FAILED',
  FETCH_CHANNEL_MANAGERS: 'FETCH_CHANNEL_MANAGERS',
  FETCH_CHANNEL_MANAGERS_SUCCESSFUL: 'FETCH_CHANNEL_MANAGERS_SUCCESSFUL',
  FETCH_CHANNEL_MANAGERS_FAILED: 'FETCH_CHANNEL_MANAGERS_FAILED',
  ADD_CHANNEL_MANAGERS: 'ADD_CHANNEL_MANAGERS',
  ADD_CHANNEL_MANAGERS_SUCCESSFUL: 'ADD_CHANNEL_MANAGERS_SUCCESSFUL',
  ADD_CHANNEL_MANAGERS_FAILED: 'ADD_CHANNEL_MANAGERS_FAILED',
  REVOKE_CHANNEL_MANAGERS: 'REVOKE_CHANNEL_MANAGERS',
  REVOKE_CHANNEL_MANAGERS_SUCCESSFUL: 'REVOKE_CHANNEL_MANAGERS_SUCCESSFUL',
  REVOKE_CHANNEL_MANAGERS_FAILED: 'REVOKE_CHANNEL_MANAGERS_FAILED',
  UPDATE_CHANNEL_MANAGERS: 'UPDATE_CHANNEL_MANAGERS',
  UPDATE_CHANNEL_MANAGERS_SUCCESSFUL: 'UPDATE_CHANNEL_MANAGERS_SUCCESSFUL',
  UPDATE_CHANNEL_MANAGERS_FAILED: 'UPDATE_CHANNEL_MANAGERS_FAILED',
  RESET_CHANNEL_MANAGERS_DATA: 'RESET_CHANNEL_MANAGERS_DATA',
  UPDATE_PLAYBACK_STATUS: 'UPDATE_PLAYBACK_STATUS',
  UPDATE_CHANNEL_DATA: 'UPDATE_CHANNEL_DATA',
  UPDATE_CHANNEL_DATA_SUCCESSFUL: 'UPDATE_CHANNEL_DATA_SUCCESSFUL',
  UPDATE_CHANNEL_DATA_FAILED: 'UPDATE_CHANNEL_DATA_FAILED', 
  RESET_UPDATE_CHANNEL_DATA_FAILED: 'RESET_UPDATE_CHANNEL_DATA_FAILED',
  ACTIVITIES_LOG_DATE: 'ACTIVITIES_LOG_DATE',
  FETCH_CHANNEL_LIST: 'FETCH_CHANNEL_LIST',
  FETCH_CHANNEL_LIST_SUCCESS: 'FETCH_CHANNEL_LIST_SUCCESS',
  FETCH_CHANNEL_LIST_FAILED: 'FETCH_CHANNEL_LIST_FAILED',
  FETCH_EMAIL_TEMPLATES: 'FETCH_EMAIL_TEMPLATES',
  FETCH_EMAIL_TEMPLATES_SUCCESSFUL: 'FETCH_EMAIL_TEMPLATES_SUCCESSFUL',
  FETCH_ALL_EMAIL_TEMPLATES_SUCCESSFUL: 'FETCH_ALL_EMAIL_TEMPLATES_SUCCESSFUL',
  FETCH_EMAIL_TEMPLATES_FAILED: 'FETCH_EMAIL_TEMPLATES_FAILED',
  DELETE_EMAIL_TEMPLATE: 'DELETE_EMAIL_TEMPLATE',
  DELETE_EMAIL_TEMPLATE_SUCCESSFUL: 'DELETE_EMAIL_TEMPLATE_SUCCESSFUL',
  DELETE_EMAIL_TEMPLATE_FAILED: 'DELETE_EMAIL_TEMPLATE_FAILED',
  ACTIVATE_EMAIL_TEMPLATE: 'ACTIVATE_EMAIL_TEMPLATE',
  ACTIVATE_EMAIL_TEMPLATE_SUCCESSFUL: 'ACTIVATE_EMAIL_TEMPLATE_SUCCESSFUL',
  ACTIVATE_EMAIL_TEMPLATE_FAILED: 'ACTIVATE_EMAIL_TEMPLATE_FAILED',
  DEACTIVATE_EMAIL_TEMPLATE: 'DEACTIVATE_EMAIL_TEMPLATE',
  DEACTIVATE_EMAIL_TEMPLATE_SUCCESSFUL: 'DEACTIVATE_EMAIL_TEMPLATE_SUCCESSFUL',
  DEACTIVATE_EMAIL_TEMPLATE_FAILED: 'DEACTIVATE_EMAIL_TEMPLATE_FAILED',
  CREATE_EMAIL_TEMPLATE: 'CREATE_EMAIL_TEMPLATE',
  CREATE_EMAIL_TEMPLATE_SUCCESSFUL: 'CREATE_EMAIL_TEMPLATE_SUCCESSFUL',
  CREATE_EMAIL_TEMPLATE_FAILED: 'CREATE_EMAIL_TEMPLATE_FAILED',
  GET_EMAIL_TEMPLATE: 'GET_EMAIL_TEMPLATE',
  GET_EMAIL_TEMPLATE_SUCCESSFUL: 'GET_EMAIL_TEMPLATE_SUCCESSFUL',
  GET_EMAIL_TEMPLATE_FAILED: 'GET_EMAIL_TEMPLATE_FAILED',
  UPDATE_EMAIL_TEMPLATE: 'UPDATE_EMAIL_TEMPLATE',
  UPDATE_EMAIL_TEMPLATE_SUCCESSFUL: 'UPDATE_EMAIL_TEMPLATE_SUCCESSFUL',
  UPDATE_EMAIL_TEMPLATE_FAILED: 'UPDATE_EMAIL_TEMPLATE_FAILED',
  SUBMIT_EMAIL_TEMPLATE: 'SUBMIT_EMAIL_TEMPLATE',
  SUBMIT_EMAIL_TEMPLATE_SUCCESS: 'SUBMIT_EMAIL_TEMPLATE_SUCCESS',
  SEND_PREVIEW_TEMPLATE: 'SEND_PREVIEW_TEMPLATE',
  SEND_PREVIEW_TEMPLATE_SUCCESSFUL: 'SEND_PREVIEW_TEMPLATE_SUCCESSFUL',
  SEND_PREVIEW_TEMPLATE_FAILED: 'SEND_PREVIEW_TEMPLATE_FAILED',
  GET_EMAIL_PREVIEW_TEMPLATE: 'GET_EMAIL_PREVIEW_TEMPLATE',
  GET_EMAIL_PREVIEW_TEMPLATE_SUCCESSFUL: 'GET_EMAIL_PREVIEW_TEMPLATE_SUCCESSFUL',
  GET_EMAIL_PREVIEW_TEMPLATE_FAILED: 'GET_EMAIL_PREVIEW_TEMPLATE_FAILED',
  SET_PREVIEW_TEMPLATE_STATUS_DEFAULT: 'SET_PREVIEW_TEMPLATE_STATUS_DEFAULT',
  FETCH_WEBCAST_ID_FOR_ASSET: 'FETCH_WEBCAST_ID_FOR_ASSET',
  FETCH_WEBCAST_ID_FOR_ASSET_SUCCESS: 'FETCH_WEBCAST_ID_FOR_ASSET_SUCCESS',
  FETCH_WEBCAST_ID_FOR_ASSET_FAILED: 'FETCH_WEBCAST_ID_FOR_ASSET_FAILED',
  FETCH_USERS_LIST: 'FETCH_USERS_LIST',
  FETCH_USERS_LIST_SUCCESSFUL: 'FETCH_USERS_LIST_SUCCESSFUL',
  FETCH_USERS_LIST_FAILED: 'FETCH_USERS_LIST_FAILED',
  RESET_USERS_LIST: 'RESET_USERS_LIST',
  FETCH_EMAIL_PREFERENCES: 'FETCH_EMAIL_PREFERENCES',
  FETCH_EMAIL_PREFERENCES_SUCCESSFUL: 'FETCH_EMAIL_PREFERENCES_SUCCESSFUL',
  FETCH_EMAIL_PREFERENCES_FAILED: 'FETCH_EMAIL_PREFERENCES_FAILED',
  FETCH_USER_ROLES: 'FETCH_USER_ROLES',
  FETCH_USER_ROLES_SUCCESSFUL: 'FETCH_USER_ROLES_SUCCESSFUL',
  FETCH_USER_ROLES_FAILED: 'FETCH_USER_ROLES_FAILED',
  UPDATE_USER_ROLES: 'UPDATE_USER_ROLES',
  UPDATE_USER_ROLES_SUCCESSFUL: 'UPDATE_USER_ROLES_SUCCESSFUL',
  UPDATE_USER_ROLES_FAILED: 'UPDATE_USER_ROLES_FAILED',
  FETCH_REALMS: 'FETCH_REALMS',
  FETCH_REALMS_SUCCESSFUL: 'FETCH_REALMS_SUCCESSFUL',
  FETCH_REALMS_FAILED: 'FETCH_REALMS_FAILED',
  CREATE_REALMS: 'CREATE_REALMS',
  CREATE_REALMS_SUCCESSFUL: 'CREATE_REALMS_SUCCESSFUL',
  CREATE_REALMS_FAILED: 'CREATE_REALMS_FAILED',
  UPDATE_REALMS: 'UPDATE_REALMS',
  UPDATE_REALMS_SUCCESSFUL: 'UPDATE_REALMS_SUCCESSFUL',
  UPDATE_REALMS_FAILED: 'UPDATE_REALMS_FAILED',
  GET_REALM_BY_ID: 'GET_REALM_BY_ID',
  GET_REALM_BY_ID_SUCCESSFUL: 'GET_REALM_BY_ID_SUCCESSFUL',
  GET_REALM_BY_ID_FAILED: 'GET_REALM_BY_ID_FAILED',
  DELETE_USER: 'DELETE_USER',
  DELETE_USER_SUCCESSFUL: 'DELETE_USER_SUCCESSFUL',
  DELETE_USER_FAILED: 'DELETE_USER_FAILED',
  GET_BASIC_EMAIL_TEMPLATE: 'GET_BASIC_EMAIL_TEMPLATE',
  GET_BASIC_EMAIL_TEMPLATE_SUCCESSFUL: 'GET_BASIC_EMAIL_TEMPLATE_SUCCESSFUL',
  GET_BASIC_EMAIL_TEMPLATE_FAILED: 'GET_BASIC_EMAIL_TEMPLATE_FAILED',
  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  FETCH_CATEGORIES_SUCCESSFUL: 'FETCH_CATEGORIES_SUCCESSFUL',
  FETCH_CATEGORIES_FAILED: 'FETCH_CATEGORIES_FAILED',
  ADD_CATEGORY: 'ADD_CATEGORY',
  ADD_CATEGORY_SUCCESSFUL: 'ADD_CATEGORY_SUCCESSFUL',
  ADD_CATEGORY_FAILED: 'ADD_CATEGORY_FAILED',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  DELETE_CATEGORY_SUCCESSFUL: 'DELETE_CATEGORY_SUCCESSFUL',
  DELETE_CATEGORY_FAILED: 'DELETE_CATEGORY_FAILED',
  RESET_USER_PASSWORD: 'RESET_USER_PASSWORD',
  RESET_USER_PASSWORD_SUCCESSFUL: 'RESET_USER_PASSWORD_SUCCESSFUL',
  RESET_USER_PASSWORD_FAILED: 'RESET_USER_PASSWORD_FAILED',
  FETCH_ALL_COMMUNITIES: 'FETCH_ALL_COMMUNITIES',
  FETCH_ALL_COMMUNITIES_SUCCESSFUL: 'FETCH_ALL_COMMUNITIES_SUCCESSFUL',
  FETCH_ALL_COMMUNITIES_FAILED: 'FETCH_ALL_COMMUNITIES_FAILED',
  FETCH_USERS_PROFILE_DETAILS: 'FETCH_USERS_PROFILE_DETAILS',
  FETCH_USERS_PROFILE_DETAILS_SUCCESSFUL: 'FETCH_USERS_PROFILE_DETAILS_SUCCESSFUL',
  FETCH_USERS_PROFILE_DETAILS_FAILED: 'FETCH_USERS_PROFILE_DETAILS_FAILED',
  UPDATE_EMAIL_PREFERENCES: 'UPDATE_EMAIL_PREFERENCES',
  UPDATE_EMAIL_PREFERENCES_SUCCESSFUL: 'UPDATE_EMAIL_PREFERENCES_SUCCESSFUL',
  UPDATE_EMAIL_PREFERENCES_FAILED: 'UPDATE_EMAIL_PREFERENCES_FAILED',
  UPDATE_PROFILE_DETAILS: 'UPDATE_PROFILE_DETAILS',
  UPDATE_PROFILE_DETAILS_SUCCESSFUL: 'UPDATE_PROFILE_DETAILS_SUCCESSFUL',
  UPDATE_PROFILE_DETAILS_FAILED: 'UPDATE_PROFILE_DETAILS_FAILED',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  UPDATE_CATEGORY_SUCCESSFUL: 'UPDATE_CATEGORY_SUCCESSFUL',
  UPDATE_CATEGORY_FAILED: 'UPDATE_CATEGORY_FAILED',
  IMAGE_PROCESSING: 'IMAGE_PROCESSING',
  IMAGE_COMPLETED: 'IMAGE_COMPLETED',
  IMAGE_NOT_FOUND: 'IMAGE_NOT_FOUND',
  IMAGE_CLEAR_LOOP_CHECK: 'IMAGE_CLEAR_LOOP_CHECK',
  IMAGE_REQUESTING_STATUS: 'IMAGE_REQUESTING_STATUS',
  IMAGE_READY: 'IMAGE_READY',
  IMAGE_FAILED: 'IMAGE_FAILED',
  FETCH_EMAIL_TYPES: 'FETCH_EMAIL_TYPES',
  FETCH_EMAIL_TYPES_SUCCESSFUL: 'FETCH_EMAIL_TYPES_SUCCESSFUL',
  FETCH_EMAIL_TYPES_FAILED: 'FETCH_EMAIL_TYPES_FAILED',
  CREATE_PRIMARY_COMMUNITY: 'CREATE_PRIMARY_COMMUNITY',
  CREATE_PRIMARY_COMMUNITY_SUCCESSFUL: 'CREATE_PRIMARY_COMMUNITY_SUCCESSFUL',
  CREATE_PRIMARY_COMMUNITY_FAILED: 'CREATE_PRIMARY_COMMUNITY_FAILED',
  FETCH_PRIMARY_COMMUNITY: 'FETCH_PRIMARY_COMMUNITY',
  FETCH_PRIMARY_COMMUNITY_SUCCESSFUL: 'FETCH_PRIMARY_COMMUNITY_SUCCESSFUL',
  FETCH_PRIMARY_COMMUNITY_FAILED: 'FETCH_PRIMARY_COMMUNITY_FAILED',
  UPDATE_PRIMARY_COMMUNITY: 'UPDATE_PRIMARY_COMMUNITY',
  UPDATE_PRIMARY_COMMUNITY_SUCCESSFUL: 'UPDATE_PRIMARY_COMMUNITY_SUCCESSFUL',
  UPDATE_PRIMARY_COMMUNITY_FAILED: 'UPDATE_PRIMARY_COMMUNITY_FAILED',
  FETCH_SUB_COMMUNITY: 'FETCH_SUB_COMMUNITY',
  FETCH_SUB_COMMUNITY_SUCCESSFUL: 'FETCH_SUB_COMMUNITY_SUCCESSFUL',
  FETCH_SUB_COMMUNITY_FAILED: 'FETCH_SUB_COMMUNITY_FAILED',
  DELETE_COMMUNITY: 'DELETE_COMMUNITY',
  DELETE_COMMUNITY_SUCCESSFUL: 'DELETE_COMMUNITY_SUCCESSFUL',
  DELETE_COMMUNITY_FAILED: 'DELETE_COMMUNITY_FAILED',
  FETCH_SUB_COMMUNITIES: 'FETCH_SUB_COMMUNITIES',
  FETCH_SUB_COMMUNITIES_SUCCESSFUL: 'FETCH_SUB_COMMUNITIES_SUCCESSFUL',
  FETCH_SUB_COMMUNITIES_FAILED: 'FETCH_SUB_COMMUNITIES_FAILED',
  GENERATE_REALM_TOKEN: 'GENERATE_REALM_TOKEN',
  GENERATE_REALM_TOKEN_SUCCESSFUL: 'GENERATE_REALM_TOKEN_SUCCESSFUL',
  GENERATE_REALM_TOKEN_FAILED: 'GENERATE_REALM_TOKEN_FAILED',
  DECRYPT_REALM_TOKEN: 'DECRYPT_REALM_TOKEN',
  DECRYPT_REALM_TOKEN_SUCCESSFUL: 'DECRYPT_REALM_TOKEN_SUCCESSFUL',
  DECRYPT_REALM_TOKEN_FAILED: 'DECRYPT_REALM_TOKEN_FAILED',
  REGENERATE_INIT_VECTOR: 'REGENERATE_INIT_VECTOR',
  REGENERATE_INIT_VECTOR_SUCCESSFUL: 'REGENERATE_INIT_VECTOR_SUCCESSFUL',
  REGENERATE_INIT_VECTOR_FAILED: 'REGENERATE_INIT_VECTOR_FAILED',
  REGENERATE_ENCRYPTION_KEY: 'REGENERATE_ENCRYPTION_KEY',
  REGENERATE_ENCRYPTION_KEY_SUCCESSFUL: 'REGENERATE_ENCRYPTION_KEY_SUCCESSFUL',
  REGENERATE_ENCRYPTION_KEY_FAILED: 'REGENERATE_ENCRYPTION_KEY_FAILED',
  CREATE_CHANNEL: 'CREATE_CHANNEL',
  CREATE_CHANNEL_SUCCESSFUL: 'CREATE_CHANNEL_SUCCESSFUL',
  CREATE_CHANNEL_FAILED: 'CREATE_CHANNEL_FAILED',
  FETCH_SUMMITS_LIST: 'FETCH_SUMMITS_LIST',
  FETCH_SUMMITS_LIST_SUCCESSFUL: 'FETCH_SUMMITS_LIST_SUCCESSFUL',
  FETCH_SUMMITS_LIST_FAILED: 'FETCH_SUMMITS_LIST_FAILED',
  RESET_SUMMITS_LIST: 'RESET_SUMMITS_LIST',
  CREATE_VIRTUAL_EVENT: 'CREATE_VIRTUAL_EVENT',
  CREATE_VIRTUAL_EVENT_SUCCESS: 'CREATE_VIRTUAL_EVENT_SUCCESS',
  CREATE_VIRTUAL_EVENT_ERROR: 'CREATE_VIRTUAL_EVENT_ERROR',
  RESET_CREATE_VIRTUAL_EVENT: 'RESET_CREATE_VIRTUAL_EVENT',
  FETCH_SUMMIT_EVENT: 'FETCH_SUMMIT_EVENT',
  FETCH_SUMMIT_EVENT_SUCCESSFUL: 'FETCH_SUMMIT_EVENT_SUCCESSFUL',
  FETCH_SUMMIT_EVENT_FAILED: 'FETCH_SUMMIT_EVENT_FAILED',
  UPDATE_VIRTUAL_EVENT: 'UPDATE_VIRTUAL_EVENT',
  UPDATE_VIRTUAL_EVENT_SUCCESS: 'UPDATE_VIRTUAL_EVENT_SUCCESS',
  UPDATE_VIRTUAL_EVENT_ERROR: 'UPDATE_VIRTUAL_EVENT_ERROR',
  CLEAR_VIRTUAL_EVENT_SERVER_ERROR: 'CLEAR_VIRTUAL_EVENT_SERVER_ERROR',
  POST_VIRTUAL_EVENT_IMAGES_CREATION: 'POST_VIRTUAL_EVENT_IMAGES_CREATION',
  POST_VIRTUAL_EVENT_IMAGES_CREATION_SUCCESS: 'POST_VIRTUAL_EVENT_IMAGES_CREATION_SUCCESS',
  POST_VIRTUAL_EVENT_IMAGES_CREATION_FAILED: 'POST_VIRTUAL_EVENT_IMAGES_CREATION_FAILED',
  VIRTUAL_EVENT_COMPANY_LOGO_UPLOAD_SUCCESS: 'VIRTUAL_EVENT_COMPANY_LOGO_UPLOAD_SUCCESS',
  VIRTUAL_EVENT_COMPANY_LOGO_UPLOAD_FAILED: 'VIRTUAL_EVENT_COMPANY_LOGO_UPLOAD_FAILED',
  VIRTUAL_EVENT_FAVICON_UPLOAD_SUCCESS: 'VIRTUAL_EVENT_FAVICON_UPLOAD_SUCCESS',
  VIRTUAL_EVENT_FAVICON_UPLOAD_FAILED: 'VIRTUAL_EVENT_FAVICON_UPLOAD_FAILED',
  VIRTUAL_EVENT_HERO_IMAGE_UPLOAD_SUCCESS: 'VIRTUAL_EVENT_HERO_IMAGE_UPLOAD_SUCCESS',
  VIRTUAL_EVENT_HERO_IMAGE_UPLOAD_FAILED: 'VIRTUAL_EVENT_HERO_IMAGE_UPLOAD_FAILED',
  VIRTUAL_EVENT_SOCIAL_MEDIA_UPLOAD_SUCCESS: 'VIRTUAL_EVENT_SOCIAL_MEDIA_UPLOAD_SUCCESS',
  VIRTUAL_EVENT_SOCIAL_MEDIA_UPLOAD_FAILED: 'VIRTUAL_EVENT_SOCIAL_MEDIA_UPLOAD_FAILED',
  FETCH_EVENT_CATEGORIES: 'FETCH_EVENT_CATEGORIES',
  FETCH_EVENT_CATEGORIES_SUCCESSFUL: 'FETCH_EVENT_CATEGORIES_SUCCESSFUL',
  FETCH_EVENT_CATEGORIES_FAILED: 'FETCH_EVENT_CATEGORIES_FAILED',
  CREATE_EVENT_CATEGORY: 'CREATE_EVENT_CATEGORY',
  CREATE_EVENT_CATEGORY_SUCCESSFUL: 'CREATE_EVENT_CATEGORY_SUCCESSFUL',
  CREATE_EVENT_CATEGORY_FAILED: 'CREATE_EVENT_CATEGORY_FAILED',
  UPDATE_EVENT_CATEGORY: 'UPDATE_EVENT_CATEGORY',
  UPDATE_EVENT_CATEGORY_SUCCESSFUL: 'UPDATE_EVENT_CATEGORY_SUCCESSFUL',
  UPDATE_EVENT_CATEGORY_FAILED: 'UPDATE_EVENT_CATEGORY_FAILED',
  DELETE_EVENT_CATEGORY: 'DELETE_EVENT_CATEGORY',
  DELETE_EVENT_CATEGORY_SUCCESSFUL: 'DELETE_EVENT_CATEGORY_SUCCESSFUL',
  DELETE_EVENT_CATEGORY_FAILED: 'DELETE_EVENT_CATEGORY_FAILED',
  RESET_UPDATE_VIRTUAL_EVENT: 'RESET_UPDATE_VIRTUAL_EVENT',
  SUBMIT_WEBCAST_UPDATE_CDN: 'SUBMIT_WEBCAST_UPDATE_CDN',
  SET_CURRENT_WEBCAST_CHANNEL_ID: 'SET_CURRENT_WEBCAST_CHANNEL_ID',
  FETCH_TRACK_COMMUNICATIONS: 'FETCH_TRACK_COMMUNICATIONS',
  FETCH_TRACK_COMMUNICATIONS_SUCCESSFUL: 'FETCH_TRACK_COMMUNICATIONS_SUCCESSFUL',
  FETCH_TRACK_COMMUNICATIONS_FAILED: 'FETCH_TRACK_COMMUNICATIONS_FAILED',
  GET_CONTENT_SUMMIT_ASSOCIATION: 'GET_CONTENT_SUMMIT_ASSOCIATION',
  GET_CONTENT_SUMMIT_ASSOCIATION_SUCCESSFUL: 'GET_CONTENT_SUMMIT_ASSOCIATION_SUCCESSFUL',
  GET_CONTENT_SUMMIT_ASSOCIATION_FAILED: 'GET_CONTENT_SUMMIT_ASSOCIATION_FAILED',
  ADD_CONTENT_TO_SUMMIT_TRACKS: 'ADD_CONTENT_TO_SUMMIT_TRACKS',
  ADD_CONTENT_TO_SUMMIT_TRACKS_SUCCESSFUL: 'ADD_CONTENT_TO_SUMMIT_TRACKS_SUCCESSFUL',
  ADD_CONTENT_TO_SUMMIT_TRACKS_FAILED: 'ADD_CONTENT_TO_SUMMIT_TRACKS_FAILED',
  DELETE_CONTENT_FROM_SUMMIT_TRACKS: 'DELETE_CONTENT_FROM_SUMMIT_TRACKS',
  DELETE_CONTENT_FROM_SUMMIT_TRACKS_SUCCESSFUL: 'DELETE_CONTENT_FROM_SUMMIT_TRACKS_SUCCESSFUL',
  DELETE_CONTENT_FROM_SUMMIT_TRACKS_FAILED: 'DELETE_CONTENT_FROM_SUMMIT_TRACKS_FAILED',
  ADD_REMOVE_TRACK_COMMUNICATIONS: 'ADD_REMOVE_TRACK_COMMUNICATIONS',
  ADD_REMOVE_TRACK_COMMUNICATIONS_SUCCESSFUL: 'ADD_REMOVE_TRACK_COMMUNICATIONS_SUCCESSFUL',
  ADD_REMOVE_TRACK_COMMUNICATIONS_FAILED: 'ADD_REMOVE_TRACK_COMMUNICATIONS_FAILED',
  FETCH_SUMMIT_AUDIENCE: 'FETCH_SUMMIT_AUDIENCE',
  FETCH_SUMMIT_AUDIENCE_SUCCESSFUL: 'FETCH_SUMMIT_AUDIENCE_SUCCESSFUL',
  FETCH_SUMMIT_AUDIENCE_FAILED: 'FETCH_SUMMIT_AUDIENCE_FAILED',
  GENERATE_EVENTS_REPORT: 'GENERATE_EVENTS_REPORT',
  EVENTS_REPORT_GENERATION_STARTED: 'EVENTS_REPORT_GENERATION_STARTED',
  EVENTS_REPORT_GENERATED_FAILED: 'EVENTS_REPORT_GENERATED_FAILED',
  FETCH_EVENTS_REPORT: 'FETCH_EVENTS_REPORT',
  FETCH_EVENTS_REPORT_SUCCESSFUL: 'FETCH_EVENTS_REPORT_SUCCESSFUL',
  FETCH_EVENTS_REPORT_FAILED: 'FETCH_EVENTS_REPORT_FAILED',
  CANCEL_FETCH_EVENTS_REPORT: 'CANCEL_FETCH_EVENTS_REPORT',
  FETCH_EVENTS_REPORT_CANCELLED: 'FETCH_EVENTS_REPORT_CANCELLED',
  CANCEL_FETCH_EVENTS_REPORT_FAILED: 'CANCEL_FETCH_EVENTS_REPORT_FAILED',
  SAVE_EVENT_REPORTS_STATUS_TIMEOUT_ID: 'SAVE_EVENT_REPORTS_STATUS_TIMEOUT_ID',
  SAVE_EVENT_REPORTS_AXIOS_CANCEL_TOKEN: 'SAVE_EVENT_REPORTS_AXIOS_CANCEL_TOKEN',
  FETCH_VIRTUAL_EVENTS_STATISTICS: 'FETCH_VIRTUAL_EVENTS_STATISTICS',
  FETCH_VIRTUAL_EVENTS_STATISTICS_SUCCESSFUL: 'FETCH_VIRTUAL_EVENTS_STATISTICS_SUCCESSFUL',
  FETCH_VIRTUAL_EVENTS_STATISTICS_FAILED: 'FETCH_VIRTUAL_EVENTS_STATISTICS_FAILED',
  FETCH_EVENT_FEATURES: 'FETCH_EVENT_FEATURES',
  FETCH_EVENT_FEATURES_SUCCESSFUL: 'FETCH_EVENT_FEATURES_SUCCESSFUL',
  FETCH_EVENT_FEATURES_FAILED: 'FETCH_EVENT_FEATURES_FAILED',
  UPDATE_EVENT_FEATURES: 'UPDATE_EVENT_FEATURES',
  UPDATE_EVENT_FEATURES_SUCCESSFUL: 'UPDATE_EVENT_FEATURES_SUCCESSFUL',
  UPDATE_EVENT_FEATURES_FAILED: 'UPDATE_EVENT_FEATURES_FAILED',
  FETCH_CAMPAIGN_FILTER: 'FETCH_CAMPAIGN_FILTER',
  FETCH_CAMPAIGN_FILTER_SUCCESS: 'FETCH_CAMPAIGN_FILTER_SUCCESS',
  FETCH_CAMPAIGN_FILTER_FAILED: 'FETCH_CAMPAIGN_FILTER_FAILED',
  UPDATE_CAMPAIGN_FILTER: 'UPDATE_CAMPAIGN_FILTER',
  UPDATE_CAMPAIGN_FILTER_SUCCESS: 'UPDATE_CAMPAIGN_FILTER_SUCCESS',
  UPDATE_CAMPAIGN_FILTER_FAILED: 'UPDATE_CAMPAIGN_FILTER_FAILED',
  RESET_UPDATE_CAMPAIGN_FILTER_FAILED: 'RESET_UPDATE_CAMPAIGN_FILTER_FAILED',
  GET_FULFILLMENT_USERS_GROUP: 'GET_FULFILLMENT_USERS_GROUP',
  GET_FULFILLMENT_USERS_GROUP_SUCCESS: 'GET_FULFILLMENT_USERS_GROUP_SUCCESS',
  GET_FULFILLMENT_USERS_GROUP_FAILED: 'GET_FULFILLMENT_USERS_GROUP_FAILED',
  GET_TOPICS: 'GET_TOPICS',
  GET_TOPICS_SUCCESSFUL: 'GET_TOPICS_SUCCESSFUL',
  GET_TOPICS_FAILED: 'GET_TOPICS_FAILED',
  GET_TOPICS_BY_RANK: 'GET_TOPICS_BY_RANK',
  GET_TOPICS_BY_RANK_SUCCESS: 'GET_TOPICS_BY_RANK_SUCCESS',
  GET_TOPICS_BY_RANK_FAILED: 'GET_TOPICS_BY_RANK_FAILED',
  GET_RELATED_TOPICS: 'GET_RELATED_TOPICS',
  GET_RELATED_TOPICS_SUCCESS: 'GET_RELATED_TOPICS_SUCCESS',
  GET_RELATED_TOPICS_FAILED: 'GET_RELATED_TOPICS_FAILED',
  GET_TOPICS_INSIGHTS: 'GET_TOPICS_INSIGHTS',
  GET_TOPICS_INSIGHTS_SUCCESSFUL: 'GET_TOPICS_INSIGHTS_SUCCESSFUL',
  GET_TOPICS_INSIGHTS_FAILED: 'GET_TOPICS_INSIGHTS_FAILED',
  CLEAR_TOPICS_INSIGHTS: 'CLEAR_TOPICS_INSIGHTS'
}

let SSEEvent

export const actions = {

  setHost: host => ({ type: actionTypes.SET_HOST, payload: host }),
  fetchChannelList: (page: number, query?: string, sort?: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CHANNEL_LIST })
    const state = getState()

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }
      let host = ''

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }else {

        headers.withCredentials = true
        
      }

      const data: {
        offset: number,
        limit: number,
        phrase?: string,
        sort?: {
          order: string,
          text: string
        }
      } = {
        offset: (page - 1) * 20,
        limit: 20
      }

      if (query) {

        data.phrase = query

      }

      if (sort) {

        data.sort = {
          text: 'title',
          order: sort
        }

      }

      if (query && query.length > 1) {

        const response = await axios.post(`${host}/service/channel/v2/channels`, { ...data }, {
          headers
        })
  
        dispatch(({ type: actionTypes.FETCH_CHANNEL_LIST_SUCCESS, payload: response.data }))

      } else {

        dispatch({ type: actionTypes.FETCH_CHANNEL_LIST_FAILED, payload: !query ? 'NO SEARCH QUERY' : 'Minimum two characters required' })

      }

    }
    catch (e) {
      const errorPayload = {
        code: get(e, 'request.status', 500),
        message: e.message
      }
      dispatch({ type: actionTypes.FETCH_CHANNEL_LIST_FAILED, payload: errorPayload })

    }

  },
  fetchChannelData: (channelId: number | string, BTSESSION?: string, featuredCommunicationsCount?: number) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CHANNEL_DATA, payload: channelId })
    const state = getState()

    let host = ''

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }else {

        headers.withCredentials = true
        
      }

      let url = `${host}/service/channel/v2/channel/${channelId}`
      if (featuredCommunicationsCount) {
        url = `${host}/service/channel/v2/channels/${channelId}?featuredCommunicationsLimit=${featuredCommunicationsCount}`
      }

      const { data } = await axios.get( url , {
        headers
      })

      dispatch(({ type: actionTypes.FETCH_CHANNEL_DATA_SUCCESS, payload: data }))

    }
    catch (e) {
      const errorPayload = {
        code: get(e, 'request.status', 500),
        message: e.message
      }
      dispatch({ type: actionTypes.FETCH_CHANNEL_DATA_ERROR, payload: errorPayload })

    }

  },
  updateChannelData: (channelId: number | string, channelData: any) => async (dispatch) => {

    dispatch({ type: actionTypes.UPDATE_CHANNEL_DATA })

    try {

      const headers: {
        Accept: string,
      } = {
        Accept: 'application/json'
      }

      const response = await axios.put(`/service/channel/v2/channel/${channelId}`, { ...channelData }, {
        headers
      })

      dispatch(({ type: actionTypes.UPDATE_CHANNEL_DATA_SUCCESSFUL, payload: response }))

    }
    catch (e) {
      const responseMessage = e && e.response && e.response.data && e.response.data.message ?
        e.response.data.message : e.message
      const code = e && e.response && e.response.data && e.response.data.code ?
        e.response.data.code : ''

      dispatch({ type: actionTypes.UPDATE_CHANNEL_DATA_FAILED, payload: { message: responseMessage, code } })

    }

  },

  resetUpdateChannelData: () => async(dispatch, getState) => {
    dispatch({type: actionTypes.RESET_UPDATE_CHANNEL_DATA_FAILED})
  },

  fetchWebcastDataByWebcastId: (webcastId) => async (dispatch, getState) => {

    const identifier = `${webcastId}`
    dispatch({ type: actionTypes.FETCH_WEBCAST_DATA, payload: { identifier, data: { id: webcastId } } })
    const state = getState()

    try {

      const { data } = await axios.get(`${state.config.host}/service/channel/channel/webcast/${webcastId}`, {
        headers: {
          Accept: 'application/json'
        }
      })

      dispatch({
        type: actionTypes.FETCH_WEBCAST_DATA_SUCCESS,
        payload: { identifier, data }
      })
      dispatch({
        type: actionTypes.FETCH_WEBCAST_DATA_SUCCESS,
        payload: { identifier: `${data.channel.id}${data.id}`, data }
      })

    }
    catch (e) {

      console.log(e)
      dispatch({ type: actionTypes.FETCH_WEBCAST_DATA_ERROR, payload: { identifier, data: e } })

    }

  },
  fetchWebcastData: (channelId: string | number, webcastId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    const identifier = `${channelId}${webcastId}`
    dispatch({ type: actionTypes.FETCH_WEBCAST_DATA, payload: { identifier, data: { id: webcastId, channel: { id: channelId } } } })
    const state = getState()

    const headers: {
      Accept: string,
      Cookie?: string,

    } = {
      Accept: 'application/json'
    }

    let url = `/service/communication/v1/channel/${channelId}/communication/${webcastId}`
    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      
      url = `${state.config.host}/service/communication/v1/channel/${channelId}/communication/${webcastId}`

    }

    try {
      const { data } = await axios.get(url, {
        headers
      })

      dispatch({
        type: actionTypes.FETCH_WEBCAST_DATA_SUCCESS,
        payload: { identifier, data }
      })

      if (data) {

        return data

      }

    }
    catch (e) {
      // TODO this is wrong in this line and should be fixed but ignoring for now to get build working
      // @ts-ignore
      if (e.response && e.response.status === 403) dispatch(this.fetchWebcastDataForbidden(identifier, e))
      else dispatch({ type: actionTypes.FETCH_WEBCAST_DATA_ERROR, payload: { identifier, data: JSON.stringify(e) } })

    }

  },
  fetchWebcastDataForbidden: (identifier, e) => ({ type: actionTypes.FETCH_WEBCAST_DATA_FORBIDDEN, payload: { identifier, data: JSON.stringify(e) } }),
  fetchPublicWebcastData: (channelId, webcastId) => async (dispatch, getState) => {

    const identifier = `${channelId}${webcastId}`
    dispatch({ type: actionTypes.FETCH_PUBLIC_WEBCAST_DATA, payload: { identifier, data: { id: webcastId, channel: { id: channelId } } } })
    const state = getState()

    try {

      const { data } = await axios.get(`${state.config.host}/service/communication/v1/channel/${channelId}/communication/${webcastId}/public`)

      dispatch({
        type: actionTypes.FETCH_PUBLIC_WEBCAST_DATA_SUCCESS,
        payload: { identifier, data }
      })

    }
    catch (e) {

      console.log(e)
      dispatch({ type: actionTypes.FETCH_WEBCAST_DATA_ERROR, payload: { identifier, data: e } })

    }

  },
  fetchPlaybackData: (channelId, webcastId) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_PLAYBACK_DATA })
    const state = getState()

    let data
    try {

      const response = await playback.xmlRequest( '', channelId, webcastId)

      if (response) {

        data = playback.handleXmlResponse(response.data)

      }

    }
    catch (e) {

      console.log(e)
      dispatch({ type: actionTypes.FETCH_PLAYBACK_DATA_ERROR, payload: e })

    }

    if (data) {

      dispatch({ type: actionTypes.FETCH_PLAYBACK_DATA_SUCCESS, payload: { ...data } })
      return data

    }
    else {

      dispatch({ type: actionTypes.FETCH_PLAYBACK_DATA_ERROR })

    }

  },
  postWebcastSubmit: (webcastId, formData) => async (dispatch, getState) => {

    const uploader = await BTUploader.initialise({
      'browse_button': document.createElement('div'),
      uploadOnly: true
    })

    const state = getState()
    let featureImageUrl = ''

    window.onbeforeunload = () => {

      const state = getState()

      return state.webcast.status.isPostProcessing ? true : undefined

    }
    const featureImagePromise = new Promise((resolve, reject) => {

      if (!(formData.featureImage instanceof Blob)) {

        // @ts-ignore
        return resolve()

      }

      uploader.on(BTUploader.FILE_UPLOADED, (file, resp) => {

        if(has(resp, 'source.location')) {
          featureImageUrl = resp.source.location
        }

        dispatch({ type: actionTypes.SELECT_FEATURE_IMAGE_UPLOAD_SUCCESS })

        // @ts-ignore
        resolve()

      })

      uploader.on(BTUploader.ERROR, (e) => {
        
        dispatch({ type: actionTypes.SELECT_FEATURE_IMAGE_UPLOAD_FAILED, payload: e })
        // @ts-ignore
        resolve()

      })

      uploader.addFile(formData.featureImage)
      try {
        uploader.start({
          type: 'featureimage',
          target: {
            id: webcastId,
            type: 'communication'
          },
          region: 'US West (California)'
        })
      } catch (e) {
        
        dispatch({ type: actionTypes.SELECT_FEATURE_IMAGE_UPLOAD_FAILED, payload: e })
        // @ts-ignore
        resolve()

      }

    })
    
    const actions = [
      featureImagePromise
    ]
    try {

      await Promise.all(actions)
      return featureImageUrl

    } catch (e) { }

  },
  fetchCommunities: (channelId, webcastId, BTSESSION) => async (dispatch, getState) => {
    const state = getState()
    let channelCommunities
    let webcastCommunities
    dispatch({ type: actionTypes.FETCHING_COMMUNITIES })

    try {

      channelCommunities = await communities.getChannelCommunities(channelId, state.config.host, BTSESSION)
    }
    catch (e) {
      dispatch({ type: actionTypes.FETCHING_COMMUNITIES_CHANNEL_FAILED, payload: e.message })

    }

    if (!channelCommunities) {

      dispatch({ type: actionTypes.FETCHING_COMMUNITIES_CHANNEL_FAILED })

    }

    if (channelCommunities && webcastId) {

      try {

        webcastCommunities = await communities.getWebcastCommunities(channelId, webcastId, state.config.host, BTSESSION)

      }
      catch (e) {

        dispatch({ type: actionTypes.FETCHING_COMMUNITIES_WEBCAST_FAILED, payload: e.message })

      }
      if (!webcastCommunities) {

        dispatch({ type: actionTypes.FETCHING_COMMUNITIES_WEBCAST_FAILED })

      }

    }

    if (channelCommunities) {
      dispatch({
        type: actionTypes.FETCHING_COMMUNITIES_SUCCESS,
        payload: {
          channelCommunities: channelCommunities.communities || [],
          webcastCommunities: (webcastCommunities && webcastCommunities.communities) || []
        }
      })

    }

  },
  submitCommunities: (channelId, webcastId, communitiesMatrix) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.SUBMITING_COMMUNITIES })
    const state = getState()

    await communities.setWebcastCommunities(channelId, webcastId, communitiesMatrix)

    dispatch({ type: actionTypes.SUBMITING_COMMUNITIES_SUCCESS })

  },
  stopCheckingFeatureImageStatus: (channelId, webcastId) => async (dispatch, getState) => {

    const uniqueKey = `${channelId}${webcastId}`
    const state = getState()
    if (state.featureImage[uniqueKey] && state.featureImage[uniqueKey].timerCheckLoop) {
      clearInterval(state.featureImage[uniqueKey].timerCheckLoop)
      dispatch({ type: actionTypes.FEATURE_IMAGE_CLEAR_LOOP_CHECK, payload: { uniqueKey } })

    }

  },
  fetchTimezoneData: () => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.FETCH_TIMEZONES })
    try {

      const { data } = await axios.get(`${state.config.host}/service/time-v2/v1/platform-timezones`, {
        headers: {
          Accept: 'application/json'
        }
      })

      if (data) {

        dispatch({ type: actionTypes.FETCH_TIMEZONES_SUCCESS, payload: [...data] })

      }
      else {

        dispatch({ type: actionTypes.FETCH_TIMEZONES_ERROR })

      }

    }
    catch (e) {

      console.log(e)
      dispatch({ type: actionTypes.FETCH_TIMEZONES_ERROR, payload: e })

    }

  },

  postBasicTemplateSubmit: (blob: Blob, channelData: any) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.POST_BASIC_TEMPLATE_CREATION })

    const uploader = await BTUploader.initialise({
      'browse_button': document.createElement('div'),
      uploadOnly: true
    })

    let imageUrl = ''
    
    const companyLogoPromise = new Promise<void>((resolve, reject) => {

      if (!(blob instanceof Blob)) {
        return resolve()

      }

      uploader.on(BTUploader.FILE_UPLOADED, async (file, resp) => {

        if(has(resp, 'source.location')) {
          imageUrl = resp.source.location
        }
        
        dispatch({ type: actionTypes.POST_BASIC_TEMPLATE_CREATION_SUCCESS })
        resolve()

      })

      uploader.on(BTUploader.ERROR, (e) => {
        dispatch({ type: actionTypes.POST_BASIC_TEMPLATE_CREATION_FAILED, payload: e })
        resolve()

      })

      try {
        uploader.addFile(blob)
        uploader.start({ 
          region: "US West (California)", 
          type: "image", 
          target: { 
               id: channelData.id,    
               type: "channel" 
             } 
          })

      } catch (e) {
        dispatch({ type: actionTypes.POST_BASIC_TEMPLATE_CREATION_FAILED, payload: e })
        resolve()

      }

    })

    const action = [
      companyLogoPromise,
    ]
    try {
    await Promise.all(action)

    if(imageUrl && imageUrl.length > 0){
    
      return imageUrl
    }
    else{
      return ''
    }
    }
    catch (e) { }
    dispatch({ type: actionTypes.POST_BASIC_TEMPLATE_SUCCESS })

  },

  setCheckCompanyLogoStatusComplete: (channelId: string) => async (dispatch) => {
      const uniqueKey = `${channelId}`
      dispatch({ type: actionTypes.IMAGE_COMPLETED, payload: { uniqueKey } })
  },

  stopCheckingImageStatus: (uniqueKey) => async (dispatch, getState) => {

    // const uniqueKey = `${id}`
    const state = getState()

    if (state.imageStatus[uniqueKey] && state.imageStatus[uniqueKey].timerCheckLoop) {
      clearInterval(state.imageStatus[uniqueKey].timerCheckLoop)
      dispatch({ type: actionTypes.IMAGE_CLEAR_LOOP_CHECK, payload: { uniqueKey } })

    }

  },

  checkUploadedImageStatus: (id = '', accountId = '', imageType = 'channel') => async (dispatch, getState) => {

    const state = getState()
    let uniqueKey = `${id}`
    let imageTargetType = imageType
    if (imageType !== 'channel') {
      uniqueKey = `${id}${accountId}${imageType}`
      imageTargetType = 'summit'
    }
    const currentImage = state.imageStatus[uniqueKey]

    if (currentImage && currentImage.isCheckingImageStatus) {

      return

    }

    return new Promise((resolve, reject) => {

      const imageProcessingTimer = setInterval(async () => {

        const res = await axios.get(`/service/ams/${imageTargetType}/${id}/settings/image`, {
          headers: {
            Accept: 'application/json'
          }
        })

        if (res.data.asset) {
          if (res.data.asset.status.state === 'processing' || res.data.asset.status.state === 'publishing') {
            dispatch({ type: actionTypes.IMAGE_PROCESSING, payload: { uniqueKey } })

          } else {
            if (res.data.asset.status.state === 'complete') {
              dispatch({ type: actionTypes.IMAGE_COMPLETED, payload: { uniqueKey, cdnUrl: res.data.asset.source.location } })
              resolve(true)

            } else if (res.data.asset.status.state === 'uploading' || res.data.asset.status.state === 'processingfailed') {
              dispatch({ type: actionTypes.IMAGE_FAILED, payload: { uniqueKey } })
              reject(false)

            } else {

              dispatch({ type: actionTypes.IMAGE_READY, payload: { uniqueKey } })
              reject(false)

            }
            dispatch(actions.stopCheckingImageStatus(uniqueKey))

          }

        }
        else {

          dispatch({ type: actionTypes.IMAGE_NOT_FOUND, payload: { uniqueKey } })
          dispatch(actions.stopCheckingImageStatus(uniqueKey))
          reject(false)

        }

      }, 1000)
      dispatch({ type: actionTypes.IMAGE_REQUESTING_STATUS, payload: { uniqueKey, data: imageProcessingTimer } })

    }).catch(err => debug(err))

  },
  
  checkFeatureImageStatus: (channelId = '', webcastId) => async (dispatch, getState) => {
    const state = getState()
    const uniqueKey = `${channelId}${webcastId}`
    const currentImage = state.featureImage[uniqueKey]

    if (currentImage && currentImage.isCheckingImageStatus) {
      return
    }

    return new Promise((resolve, reject) => {
      
      const imageProcessingTimer = setInterval(async () => {

        const res = await axios.get(`/service/ams/communication/${webcastId}/settings/featureimage`, {
          headers: {
            Accept: 'application/json'
          }
        })

        if (res.data.asset) {

          if (res.data.asset.status.state === 'processing' || res.data.asset.status.state === 'publishing') {

            dispatch({ type: actionTypes.FEATURE_IMAGE_PROCESSING, payload: { uniqueKey } })

          } else {

            if (res.data.asset.status.state === 'complete') {

              dispatch({ type: actionTypes.FEATURE_IMAGE_COMPLETED, payload: { uniqueKey, cdnUrl: res.data.asset.source && res.data.asset.source.location || "" } })
              resolve(true)

            } else if (res.data.asset.status.state === 'uploading' || res.data.asset.status.state === 'processingfailed') {

              dispatch({ type: actionTypes.FEATURE_IMAGE_FAILED, payload: { uniqueKey } })
              reject(false)

            } else {

              dispatch({ type: actionTypes.FEATURE_IMAGE_READY, payload: { uniqueKey } })
              reject(false)

            }
            dispatch(actions.stopCheckingFeatureImageStatus(channelId, webcastId))

          }

        } else {

          dispatch({ type: actionTypes.FEATURE_IMAGE_NOT_FOUND, payload: { uniqueKey } })
          dispatch(actions.stopCheckingFeatureImageStatus(channelId, webcastId))
          reject(false)

        }

      }, 1000)
      dispatch({ type: actionTypes.FEATURE_IMAGE_REQUESTING_STATUS, payload: { uniqueKey, data: imageProcessingTimer } })

    }).catch(err => debug(err))

  },
  clearServerError: id => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CLEAR_SERVER_ERROR, payload: id })

  },
  createWebcast: (formData) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.SUBMIT_WEBCAST, payload: formData })
    const state = getState()
    let newWebcast
    let flag = true

    try {

      const { data } = await webcastServices.post({ ...formData })
      newWebcast = data

    }
    catch (e) {

      if (has(e, 'response.data')) {

        flag = false
        dispatch({ type: actionTypes.SUBMIT_WEBCAST_ERROR, payload: e.response.data })

      }

    }

    if (flag) {

      if (newWebcast) {
        await dispatch(actions.uploadFeatureImage(newWebcast, formData))
        dispatch({type: actionTypes.SUBMIT_WEBCAST_SUCCESS, payload: newWebcast})

      } else {

        dispatch({ type: actionTypes.SUBMIT_WEBCAST_ERROR, payload: {code: 'error', message: 'Failed to create'} })

      }

    }

  },
  resetCreation: () => ({ type: actionTypes.RESET_CREATION, payload: null }),
  editWebcast: (formData, updateOnly = false) => async (dispatch, getState) => {

    const state = getState()
    const uniqueKey = `${formData.channel.id}${formData.id}`
    const webcastData = state.webcast.collection[uniqueKey]
    const webcast = webcastData && webcastData.status.hasData ? webcastData.data : undefined

    await dispatch(actions.uploadFeatureImage(webcast, formData, updateOnly, 'edit'))

  },
  uploadFeatureImage: (webcast, formData, updateOnly = false, operationType = '') => async (dispatch, getState) => {
    if (operationType === 'edit' ) {
      dispatch({ type: actionTypes.SUBMIT_WEBCAST, payload: formData })
    }
    
    dispatch({ type: actionTypes.POST_WEBCAST_CREATION })
    
    const channelId = formData.provider === 'video' ? Number(formData.channel.id) : webcast.channel.id
    const webcastId = formData.provider === 'video' ? formData.id : webcast.id
    let flag = true

    const featureImageUrl = await dispatch(actions.postWebcastSubmit(webcastId, formData))

    if ((featureImageUrl && featureImageUrl !== "") || operationType === 'edit') {

      if (operationType === '') {
        dispatch({ type: actionTypes.SUBMIT_WEBCAST, payload: formData })
      }

      let webcastData

      if (operationType === '') {
        formData.id = webcast.id
      }

      if (featureImageUrl && featureImageUrl !== "") {
        formData.links = [
          { href: featureImageUrl, title: "preview" },
          { href: featureImageUrl, title: "thumbnail" }
        ]
      }

      try {
      
        const { data } = await webcastServices.edit(formData)
        webcastData = data

      } catch (e) {
        if (has(e, 'response.data')) {
          flag = false
          dispatch({ type: actionTypes.SUBMIT_WEBCAST_ERROR, payload: e.response.data })
        }
      }

      if (flag) {
        if (webcastData) {
          if (!updateOnly) {
            dispatch({ type: actionTypes.SUBMIT_WEBCAST_SUCCESS_EDIT, payload: webcastData })
          } else {
            dispatch({ type: actionTypes.SUBMIT_WEBCAST_SUCCESS, payload: webcastData })
          }
        } else {
          dispatch({ type: actionTypes.SUBMIT_WEBCAST_ERROR, payload: { code: 'error', message: 'Failed to edit' } })
        }
      }

    }

    if (flag) {
      dispatch({ type: actionTypes.SUBMITING_COMMUNITIES })
      if (isEmpty(formData.communitiesMatrix)) {
        formData.communitiesMatrix = { communities: [] }
      }

      const communitiesPromise = [
        communities.setWebcastCommunities(channelId, webcastId, formData.communitiesMatrix)
      ]
      try {
        await Promise.all(communitiesPromise)
      } catch (e) {}
    
      dispatch({ type: actionTypes.SUBMITING_COMMUNITIES_SUCCESS })
    }

    dispatch({ type: actionTypes.POST_WEBCAST_CREATION_SUCCESS })

  },
  cancelWebcast: (formData) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CANCEL_WEBCAST, payload: formData })
    const state = getState()

    let webcast

    try {

      const { data } = await webcastServices.cancelWebcast(formData, state.config.host)
      webcast = data

    }
    catch (e) {

      if (has(e, 'response.data')) {

        dispatch({ type: actionTypes.CANCEL_WEBCAST_ERROR, payload: e.response.data })

      }

    }

    if (webcast) {

      dispatch({ type: actionTypes.CANCEL_WEBCAST_SUCCESS, payload: webcast })

    }

  },
  fetchChannelCommunications: (identifier, params, merge, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_COMMUNICATIONS, payload: { identifier } })

    interface CommunicationSearch {
      channel?,
      offset?,
      sort?,
      limit?,
      providers?,
      status?,
      publishStatus?,
      visibilities?,
      includeCategories?,
      includeSyndicationDetails?,
      ids?,
      phrase?,
      time?,
      syndication?,
      excludedChannels?
    }

    const data: CommunicationSearch = { }

    if (params.channelId) {
      data.channel = {
        id: params.channelId
      }
    }

    if (params.excludedChannels) {

      data.excludedChannels = params.excludedChannels

    }

    if (params.offset >= 0) {

      data.offset = params.offset

    }

    if (params.sortOrder && params.sortName) {

      data.sort = {
        order: params.sortOrder,
        name: params.sortName
      }

    }

    if (params.limit) {

      data.limit = params.limit

    }

    if (params.providers) {

      data.providers = params.providers

    }

    if (params.status) {

      data.status = params.status

    }

    if (params.publishStatus) {

      data.publishStatus = params.publishStatus

    }

    if (params.visibilities) {

      data.visibilities = params.visibilities

    }

    if (params.includeCategories !== undefined && params.includeCategories !== null) {

      data.includeCategories = params.includeCategories

    }

    if (params.includeSyndicationDetails !== undefined && params.includeSyndicationDetails !== null) {

      data.includeSyndicationDetails = params.includeSyndicationDetails

    }

    if (params.limit) {

      data.limit = params.limit

    }

    if (params.ids && params.ids.length > 0) {

      data.ids = params.ids

    }

    if (params.query && params.query.length > 0) {

      data.phrase = params.query

    }

    if (params.startTime || params.endTime) {

      data.time = {
        start: params.startTime,
        end: params.endTime
      }

    }

    if (params.syndicationType || params.syndicationAuthorisation) {

      data.syndication = { 
        type: params.syndicationType,
        authorisation: params.syndicationAuthorisation
      }

    }

    try {

      const headers: {
        Accept: string,
        Cookie?: string
      } = {
        Accept: 'application/json'
      }
  
      const state = getState()
      let host = ''

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + BTSESSION
  
        if (state && state.config && state.config.host) {
  
          host = state.config.host
        }
  
      }

      const res = await axios.post(`${host}/service/communication/v1/communications`, data, { headers })
      dispatch({
        type: actionTypes.FETCH_COMMUNICATIONS_SUCCESS,
        payload: { ...res.data, identifier, merge, offset: params.offset, limit: params.limit }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_COMMUNICATIONS_FAILED, payload: { data: e, identifier } })

    }

  },

  fetchActivity: (type, channelId) => async (dispatch) => {

    dispatch({ type: actionTypes.FETCH_ACTIVITY, payload: { type, channelId } })

    try {

      const res = await axios.get(`/service/activity/v1/channel/${channelId}/key/${type}`)
      dispatch({
        type: actionTypes.FETCH_ACTIVITY_SUCCESS,
        payload: { data: res.data, type }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_ACTIVITY_FAILED, payload: { data: e, type } })

    }

  },

  putActivity: (type, channelId, params) => async (dispatch) => {

    dispatch({ type: actionTypes.PUT_ACTIVITY, payload: { type, channelId, params } })

    const data = {
      key: type,
      body: params
    }

    try {

      const res = await axios.put(`/service/activity/v1/channel/${channelId}`, data)
      dispatch({
        type: actionTypes.PUT_ACTIVITY_SUCCESS,
        payload: { data: res.data, type }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.PUT_ACTIVITY_FAILED, payload: { data: e, type } })

    }

  },

  generateChannelReport: (type: string, channelId: string | number, webcastId?: string | number, from?: string, to?: string, activities?: Array<string>) => async (dispatch) => {

    dispatch({ type: actionTypes.GENERATE_CHANNEL_REPORT, payload: { type, channelId, from, to, activities } })

    const data: GenChannelReportReqData = {
      type,
      channelId
    }

    if (webcastId) {

      data.webcastId = webcastId

    }

    if (from || to || activities) {

      data.filters = {
        dateRange: {
          from: from || undefined,
          to: to || undefined
        },
        activities: activities || undefined
      }

    }

    try {

      const headers = { 
        Accept: 'application/json',
        withCredentials: true
      }

      const res = await axios.post(`/service/monet/channel-report/generate`, data, { headers })

      dispatch({
        type: actionTypes.CHANNEL_REPORT_GENERATION_STARTED,
        payload: { reportId: Number(res.data.reportId), type }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.CHANNEL_REPORT_GENERATED_FAILED, payload: { error: e, type } })

    }

  },

  fetchChannelReportStatus: (type, reportId) => async (dispatch) => {

    dispatch({ type: actionTypes.FETCH_CHANNEL_REPORT_STATUS, payload: { reportId, type } })

    try {

      const events = new EventSource(`/service/monet/channel-report/status?reportId=${reportId}`)
      SSEEvent = events

      events.onmessage = async (event) => {

        const response = JSON.parse(event.data)

        if (response.status === 'completed') {

          dispatch({
            type: actionTypes.FETCH_CHANNEL_REPORT_SUCCESSFUL,
            payload: { reportUrl: response.reportUri, reportId, type }
          })
          if (events) {
            events.close()
          }

        }
        else if (response.status === 'failed') {

          dispatch({ type: actionTypes.FETCH_CHANNEL_REPORT_FAILED, payload: { error: 'No data found.', type } })
          if (events) {
            events.close()
          }

        }

      }

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_CHANNEL_REPORT_FAILED, payload: { error: e, type } })

    }

  },

  cancelFetchChannelReportStatus: (type) => async (dispatch) => {

    dispatch({ type: actionTypes.CANCEL_FETCH_CHANNEL_REPORT_STATUS, payload: { type } })

    try {

      if (SSEEvent) {
        SSEEvent.close()
      }
      dispatch({ type: actionTypes.FETCH_CHANNEL_REPORT_STATUS_CANCELLED, payload: { type } })

    }

    catch (e) {

      dispatch({ type: actionTypes.CANCEL_FETCH_CHANNEL_REPORT_STATUS_FAILED, payload: { error: e, type } })

    }

  },

  fetchSyndicationDetails: (channelId: string | number, communicationId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SYNDICATION_DETAILS, payload: { channelId, communicationId } })

    const headers: {
      Accept: string,
      Cookie?: string
    } = {
      Accept: 'application/json'
    }

    const state = getState()
    let host = ''

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)

      if (state && state.config && state.config.host) {

        host = state.config.host
      }

    }

    try {

      const response = await axios.get(`${host}/service/communication/v1/channel/${channelId}/communication/${communicationId}/syndications`, {
        headers
      })

      dispatch({
        type: actionTypes.SYNDICATION_DETAILS_FETCHED_SUCCESSFULLY,
        payload: { data: response.data, communicationId }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.SYNDICATION_DETAILS_FETCH_FAILED, payload: { data: JSON.stringify(e), communicationId } })

    }

  },
  removeSyndication: (channelId, communicationId) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.REMOVE_SYNDICATION, payload: { channelId, communicationId } })
    try {
      await axios.delete(`/service/communication/v1/channel/${channelId}/communication/${communicationId}/syndication`)
      dispatch({
        type: actionTypes.REMOVE_SYNDICATION_SUCCESS,
        payload: { communicationId }
      })
    }

    catch (e) {
      dispatch({ type: actionTypes.REMOVE_SYNDICATION_FAILED, payload: e })
    }
  },
  fetchActivities: (activitiesReqDetails: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_ALL_ACTIVITIES })

    const headers: {
      Accept: string,
      Cookie?: string
    } = {
      Accept: 'application/json'
    }

    const params = activitiesReqDetails

    let host = ''
    const state = getState()

    if (BTSESSION && state && state.config) {

      headers.Cookie = 'BTSESSION=' + encodeURI(BTSESSION)
      host = state.config.host

    }

    try {

      const response = await axios.get(`${host}/service/monet/channel-report/latest-activity`,
                        {
                          headers,
                          params
                        })
      dispatch({
        type: actionTypes.FETCH_ALL_ACTIVITIES_SUCCESSFUL,
        payload: { 
          data: response.data.results,
          total: response.data.totalActivity
        }
      })

      dispatch({
        type: actionTypes.ACTIVITIES_LOG_DATE,
        payload: {
          firstActivityDate: response.data.firstActivityDate || "" ,
          lastActivityDate: response.data.lastActivityDate || ""
        }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_ALL_ACTIVITIES_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  fetchAudienceSummary: (channelId: string | number, communicationId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_AUDIENCE_SUMMARY, payload: { channelId, communicationId } })
    const state = getState()
    try {
      const headers: {
        Accept: string,
        Cookie?: string
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)

      }

      const response = await axios.get(`${BTSESSION ? state.config.host : ''}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/audience/summary`, { headers })

      dispatch({
        type: actionTypes.FETCH_AUDIENCE_SUMMARY_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      console.log('Error', e.message)
      dispatch({ type: actionTypes.FETCH_AUDIENCE_SUMMARY_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  fetchQuestionsCount: (channelId: string | number | null, communicationId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_QUESTIONS_COUNT, payload: { communicationId } })

    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean
    } = {
      Accept: 'application/json'
    }

    const state = getState()

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + BTSESSION

    }else {

      headers.withCredentials = true
      
    }

    try {

      const response = await axios.get(`${BTSESSION ? state.config.host : ''}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/questions/count`, {
        headers
      })
      dispatch({
        type: actionTypes.FETCH_QUESTIONS_COUNT_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_QUESTIONS_COUNT_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  fetchFeedbackSummary: (channelId: string | number, communicationId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_FEEDBACK_SUMMARY, payload: { channelId, communicationId } })

    const headers: {
      Accept: string,
      Cookie?: string
    } = {
      Accept: 'application/json'
    }
    let host = ''

    const state = getState()

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + BTSESSION
      host = state.config.host

    }

    try {

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/feedback/summary`, {
        headers
      })
      dispatch({
        type: actionTypes.FETCH_FEEDBACK_SUMMARY_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_FEEDBACK_SUMMARY_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  fetchAudienceChart: (channelId: string | number, communicationId: string | number, BTSESSION?: string) => async (dispatch, getState) => {
    
    dispatch({ type: actionTypes.FETCH_AUDIENCE_CHART, payload: { channelId, communicationId } })

    const state = getState()

    try {
      const headers: {
        Accept: string,
        Cookie?: string
      } = {
        Accept: 'application/json'
      }
      let host = ''
  
      const state = getState()
  
      if (BTSESSION) {
  
        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host
  
      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/audience/chart`, { headers })

      dispatch({
        type: actionTypes.FETCH_AUDIENCE_CHART_SUCCESSFUL,
        payload: { data: response && response.data && response.data.data && response.data.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_AUDIENCE_CHART_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },
  fetchLiveViewers: (channelId, communicationId, BTSESSION?) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_LIVE_VIEWERS, payload: { channelId, communicationId } })
    const state = getState()

    try {
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/audience/live/summary`, { headers })

      dispatch({
        type: actionTypes.FETCH_LIVE_VIEWERS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_LIVE_VIEWERS_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  approveSyndication: (channelId, communicationId, approvalInfo) => async (dispatch) => {
    
    dispatch({ type: actionTypes.APPROVE_SYNDICATION, payload: { channelId, communicationId } })

    try {

      const response = await axios.put(`/service/communication/v1/channel/${channelId}/communication/${communicationId}/syndication`,
        approvalInfo
      )

      dispatch({
        type: actionTypes.APPROVE_SYNDICATION_SUCCESS,
        payload: { data: response.data }
      })

    }

    catch (e) {
      dispatch({ type: actionTypes.APPROVE_SYNDICATION_FAILED, payload: { data: JSON.stringify(e) } })
    }
  },
  fetchAudienceViewingChart: (channelId, communicationId, viewingType, BTSESSION?) => async (dispatch, getState) => {

    dispatch({ type: viewingType == 'live' ? actionTypes.FETCH_AUDIENCE_VIEWING_CHART : viewingType == 'recorded' ? actionTypes.FETCH_AUDIENCE_GROWTH_CHART : '', payload: { channelId, communicationId } })

    const state = getState()

    try {

      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }


      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/audience/${viewingType}/chart`, {headers})


      dispatch({
        type: viewingType == 'live' ? actionTypes.FETCH_AUDIENCE_VIEWING_CHART_SUCCESSFUL : viewingType == 'recorded' ? actionTypes.FETCH_AUDIENCE_GROWTH_CHART_SUCCESSFUL : '',
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: viewingType == 'live' ? actionTypes.FETCH_AUDIENCE_VIEWING_CHART_FAILED : viewingType == 'recorded' ? actionTypes.FETCH_AUDIENCE_GROWTH_CHART_FAILED : '', payload: { data: JSON.stringify(e) } })

    }

  },

  fetchOndemandViewers: (channelId, communicationId) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_ONDEMAND_VIEWERS, payload: { channelId, communicationId } })

    const state = getState()

    try {
      const headers = {
        Accept: 'application/json',
        withCredentials: true
      }

      const response = await axios.get(`/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/audience/recorded/summary`, { headers })

      dispatch({
        type: actionTypes.FETCH_ONDEMAND_VIEWERS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_ONDEMAND_VIEWERS_FAILED, payload: { data: e } })

    }

  },
  createSyndication: (channelId, communicationId) => async (dispatch) => {
    
    dispatch({ type: actionTypes.CREATE_SYNDICATION, payload: { channelId, communicationId } })

    try {

      const response = await axios.post(`/service/communication/v1/channel/${channelId}/communication/${communicationId}/syndication`, {}, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })

      return dispatch({
        type: actionTypes.CREATE_SYNDICATION_SUCCESS,
        payload: { data: response.data }
      })

    }

    catch (e) {
      return dispatch({ type: actionTypes.CREATE_SYNDICATION_FAILED, payload: { data: JSON.stringify(e) } })
    }

  },
  fetchSubscriberList: ({ channelId, offset, limit, sortBy, sortByOrder, phrase, startTime, endTime }: SubscribersListTypes, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SUBSCRIBER_LIST, payload: { channelId } })

    interface SubscriberList {
      channelId,
      offset,
      limit,
      sortBy,
      sortByOrder,
      phrase?,
      time?: {
        start,
        end
      }
    }

    const data: SubscriberList = {
      channelId,
      offset,
      limit,
      sortBy,
      sortByOrder,
    }

    if (phrase) {

      data.phrase = phrase

    }

    if (startTime && endTime) {

      data.time = {
        start: startTime,
        end: endTime
      }

    }

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.post(`${host}/service/monet/channel-report/channelsubscriber`, data, { headers })
      dispatch({
        type: actionTypes.FETCH_SUBSCRIBER_LIST_SUCCESSFUL,
        payload: { data: response.data.subscribers.subscriber, total: response.data.subscribers.quantity }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_SUBSCRIBER_LIST_FAILED, payload: { data: JSON.stringify(e) } })
    }
  },
  fetchSubscriberGrowthChart: (channelId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SUBSCRIBER_GROWTH_CHART, payload: { channelId } })

    const state = getState()

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${state.config.host}/service/monet/channel-report/channel/${channelId}/subscribers/data/monthly`, { headers })

      dispatch({
        type: actionTypes.FETCH_SUBSCRIBER_GROWTH_CHART_SUCCESSFUL,
        payload: { data: response.data.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_SUBSCRIBER_GROWTH_CHART_FAILED, payload: { data: JSON.stringify(e) } })


    }

  },

  fetchContentPerformanceChart: (channelId: string | number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CONTENT_PERFORMANCE_CHART, payload: { channelId } })

    const state = getState()

    try {
      const headers = {
        Accept: 'application/json',
        Cookie: 'BTSESSION=' + BTSESSION
      }

      const response = await axios.get(`/service/monet/channel-report/channel/${channelId}/data/audience`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_CONTENT_PERFORMANCE_CHART_SUCCESSFUL,
        payload: { data: response.data.data }
      })
    }

    catch (e) {
      dispatch({ type: actionTypes.FETCH_CONTENT_PERFORMANCE_CHART_FAILED, payload: { data: e } })
    }
  },
  fetchQuestions: (channelId, communicationId ,offset , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_QUESTIONS_LIST, payload: { channelId, communicationId } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/questions?offset=${offset}&limit=6&sortBy=created&sortByOrder=desc`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_QUESTIONS_LIST_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_QUESTIONS_LIST_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  fetchAttachmentDownloadCount: (channelId, communicationId, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_ATTACHMENT_DOWNLOAD_COUNT, payload: { channelId, communicationId } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/attachments/download-count`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_ATTACHMENT_DOWNLOAD_COUNT_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_ATTACHMENT_DOWNLOAD_COUNT_FAILED, payload: { data: JSON.stringify(e) } })
    }
  },

  fetchAttachments: (channelId, communicationId, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_ATTACHMENTS, payload: { channelId, communicationId } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/attachments`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_ATTACHMENTS_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_ATTACHMENTS_FAILED, payload: { data: JSON.stringify(e) } })
    }
  },

  fetchVotesCount: (channelId, communicationId, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_VOTES_COUNT, payload: { channelId, communicationId } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/votes/count`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_VOTES_COUNT_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_VOTES_COUNT_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  fetchVotes: (channelId, communicationId ,offset , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_VOTES_LIST, payload: { channelId, communicationId } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/votes?offset=${offset}&limit=2&sortBy=created&sortByOrder=desc`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_VOTES_LIST_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_VOTES_LIST_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  fetchFeedbackData: (channelId ,communicationId, offset?: number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_FEEDBACK_DATA, payload: { channelId, communicationId } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/monet/channel-report/${channelId ? `channel/${channelId}` : `channels`}/communication/${communicationId}/feedback${offset ? `?offset=${offset}` : ''}`, { headers })
      dispatch({
        type: actionTypes.FETCH_FEEDBACK_DATA_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_FEEDBACK_DATA_FAILED, payload: { data: JSON.stringify(e) } })
    }
  },
  fetchWebcastIdForAsset: (accountId, channelId) => async (dispatch, getState) => {
    dispatch({
      type: actionTypes.FETCH_WEBCAST_ID_FOR_ASSET
    })
    try {

      const response = await axios.post(`/service/assetlink/account/${accountId}/channel/${channelId}`)
      dispatch({
        type: actionTypes.FETCH_WEBCAST_ID_FOR_ASSET_SUCCESS,
        payload: { accountId, channelId, webcastId: response.data.communicationId }
      })
      return response.data.communicationId
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_WEBCAST_ID_FOR_ASSET_FAILED, payload: { data: JSON.stringify(e) } })
    }
  },

  /*
  *
  * This function used to re upload the video
  *
  */
  reuploadVideo: (formData, channelId, webcastId) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.REUPLOAD_VIDEO, payload: formData.file })

    const state = getState()
    
    const region = AssetUploadLocation(state.currentUser.currentUser.timeZone)

    const uploader = await BTUploader.initialise({
      'browse_button': document.createElement('div'),
      uploadOnly: true,
      filters: {
        'max_file_size': '5000mb'
      }
    })

    window.onbeforeunload = () => {

      const state = getState()

      return ['uploading'].indexOf(state.playback.status.upload) > -1 ? true : undefined

    }

    const uploadFilePromise = new Promise<void>((resolve, reject) => {
      if (!(formData.file instanceof Blob)) {

        return resolve()

      }

      uploader.on(BTUploader.FILE_UPLOADED, (file) => {

        dispatch({ type: actionTypes.VIDEO_UPLOAD_SUCCESS })
        dispatch(actions.checkVideoUploadStatus(channelId, webcastId, file.id, 'upload'))
        resolve()

      })

      uploader.on(BTUploader.PROGRESS, (file, bytePerSec) => {

        dispatch({ type: actionTypes.VIDEO_UPLOADING_STATE, payload: {id: file.id, file: file.file, bytePerSec}})
        resolve()

      })

      uploader.on(BTUploader.PROCESSING, (file, byte) => {

        dispatch({ type: actionTypes.VIDEO_PROCESSING_STATE })

      })

      uploader.on(BTUploader.FILE_FINISHED, (file) => {

        dispatch({ type: actionTypes.VIDEO_PROCESS_SUCCESS })
        dispatch(actions.fetchWebcastData(channelId, webcastId))

      })

      uploader.on(BTUploader.FILE_CANCELLED, (file) => {

        const state = getState()
        const formData = {
          id: webcastId,
          channel: {
            id: channelId
          },
          provider: state.webcast.collection[`${channelId}${webcastId}`].data.provider,
          status: 'recorded'
        }
        dispatch({ type: actionTypes.VIDEO_UPLOAD_CANCELLED })
        dispatch(actions.editWebcast(formData, true))
  
      })

      uploader.on(BTUploader.ERROR, (e) => {

        dispatch({ type: actionTypes.VIDEO_UPLOAD_FAILED, payload: e.message })
        resolve()

      })

      try {
        uploader.addFile(formData.file)
    
        uploader.start({
          type: 'video-screencast',
          target: {
            id: webcastId,
            type: 'communication'
          },
          region: region
        })
        dispatch({ type: actionTypes.ADD_UPLOADER, payload: uploader})
      } catch (e) {

        dispatch({ type: actionTypes.VIDEO_UPLOAD_FAILED, payload: e.message })
        resolve()

      }

    })

    const action = [
      uploadFilePromise
    ]
    try {

      await Promise.all(action)

    }
    catch (e) {
      dispatch({ type: actionTypes.VIDEO_UPLOAD_FAILED, payload: e.message })
    }

  },

  checkVideoUploadStatus: (channelId, webcastId, assetId, state) => async (dispatch): Promise<void> => {

    const uploadProcessingTimer = setInterval(async () => {

      try {
        const url = `/service/ams/asset/${assetId}`
        const res = await dispatch(actions.getUploadedImage(url))
        if (res.data.id) {
          if (['complete', 'cancelled'].includes(res.data.status.state)) {
            clearInterval(uploadProcessingTimer)
            dispatch({ type: actionTypes.VIDEO_PROCESS_SUCCESS, payload: { state: res.data.status.state } })
            dispatch(actions.fetchWebcastData(channelId, webcastId))

          } else {
            if (state !== 'upload') {
              dispatch({ type: actionTypes.VIDEO_TRANSCODING_STATE, payload: {percent: res.data.status.progress, id: assetId} })
            } else {
              dispatch({ type: actionTypes.VIDEO_PROCESSING_STATE, payload: res.data.status.progress})
            }
            if (res.data.status.state === 'processingfailed') {
              dispatch({ type: actionTypes.FETCH_PLAYBACK_STATUS_ERROR })
              dispatch({ type: actionTypes.UPDATE_WEBCAST_STATUS, payload: { status: 'recorded', channelId, webcastId} })
            }
          }
        }
      } catch (e) {

        clearInterval(uploadProcessingTimer)
      }

    }, 5000)
    dispatch({ type: actionTypes.SAVE_STATUS_INTERVAL, payload: uploadProcessingTimer})
  },

  cancelVideoUpload: (fileId, channelId, webcastId) => async (dispatch, getState) => {

    try {
      const state = getState()
      if (state.playback.uploader) {
        state.playback.uploader.destroy()
      }
      if (fileId) {
        const response = await axios.put(`/service/ams/asset/${fileId}`, {id: webcastId, status: {state: 'cancelled'}})
      }
      dispatch({ type: actionTypes.VIDEO_UPLOAD_CANCELLED })
    } catch (e) {
      const status = get(e, 'request.status', 500)
      let errorMessage = {}

      switch (status) {

        case 500:
          errorMessage = {
            code: 500,
            message: ServiceError.NETWORK_ERROR
          }
          break
        default:
          errorMessage = {
            code: e.request.status,
            message: e.message
          }

      }
    }

  },

  getUploadedImage: (url) => async (dispatch) => {

    try {
  
      const res = await axios.get(url, {
        headers: {
          Accept: 'application/json'
        }
      })
  
      return res
    } catch(e) {
      throw new Error(e.message)
    }
  
  },

  fetchPlaybackStatus: (channelId, webcastId) => async (dispatch) => {

    try {
      dispatch({ type: actionTypes.FETCH_PLAYBACK_STATUS })

      const url = `/service/ams/communication/${webcastId}/settings/video`
      const res = await dispatch(actions.getUploadedImage(url))
      if (res.data.asset && res.data.asset.status && res.data.asset.status && res.data.asset.status.state) {
        if (['processingfailed', 'cancelled', 'uploading'].indexOf(res.data.asset.status.state) === -1) {
          dispatch(actions.checkVideoUploadStatus(channelId, webcastId, res.data.asset.id, ''))
        } else {
          dispatch({ type: actionTypes.FETCH_PLAYBACK_STATUS_ERROR, payload: res.data.asset.status.state })
        }
      } else {
        dispatch({ type: actionTypes.FETCH_PLAYBACK_STATUS_ERROR, payload: 'noVideo' })
      }
    } catch (e) {
      dispatch({ type: actionTypes.FETCH_PLAYBACK_STATUS_ERROR })
    }

  },

  fetchChannelManagers: (channelId: number | string, page?: number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CHANNEL_MANAGERS, payload: channelId })
    const state = getState()

    try {

      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' +  encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const { data } = await axios.get(`${host}/service/channel/v2/channel/${channelId}/channel_managers?pageSize=20&page=${page || 1}`, {
        headers
      })

      dispatch(({ type: actionTypes.FETCH_CHANNEL_MANAGERS_SUCCESSFUL, payload: { data: data.channelManagers || [], total: data.total || 0 } }))

    }
    catch (e) {

      dispatch({ type: actionTypes.FETCH_CHANNEL_MANAGERS_FAILED, payload: JSON.stringify(e) })

    }

  },

  addChannelManagers: (channelId: number | string, emails: string, accessLevel: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.ADD_CHANNEL_MANAGERS, payload: emails })
    const state = getState()

    try {

      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + BTSESSION
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const channelManagers: any = []
      emails.split(',').forEach((email) => {
        channelManagers.push({
          user: {
            email: email.trim()
          }
        })
      })

      const { data } : any = await axios.post(`${host}/service/channel/v2/channel/${channelId}/channel_managers`, {
        channelManagers,
        accessLevel
      })

      dispatch(({ type: actionTypes.ADD_CHANNEL_MANAGERS_SUCCESSFUL, payload: { data: data.channelManagers, errors: data.errors } }))

    }
    catch (e) {

      let code = '', statusCode = '', message = ''

      if (has(e, 'response.data.code')) {
        code = e.response.data.code
      }

      if (has(e, 'response.data.message')) {
        message = e.response.data.message
      }

      if (has(e, 'response.status')) {
        statusCode = e.response.status
      }

      dispatch({ type: actionTypes.ADD_CHANNEL_MANAGERS_FAILED, payload: { errors: e, code, statusCode, message } })

    }

  },

  revokeChannelManagers: (channelId: number | string, channelManagerId: number | string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.REVOKE_CHANNEL_MANAGERS, payload: channelManagerId })
    const state = getState()

    try {

      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + BTSESSION
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      await axios.delete(`${host}/service/channel/v2/channel/${channelId}/channel_manager/${channelManagerId}`)

      dispatch(({ type: actionTypes.REVOKE_CHANNEL_MANAGERS_SUCCESSFUL, payload: channelManagerId }))

    }
    catch (e) {
      dispatch({ type: actionTypes.REVOKE_CHANNEL_MANAGERS_FAILED, payload: e })

    }

  },

  updateChannelManagers: (channelId: number | string, channelManagerId: number | string, emailAlerts: boolean | null,  accessLevel: string | null, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_CHANNEL_MANAGERS, payload: emailAlerts })
    const state = getState()

    try {

      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + BTSESSION
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const requestData: any = {}
      requestData.id = channelManagerId

      if (emailAlerts !== null) {
        requestData.emailAlerts = emailAlerts
      }

      if (accessLevel !== null) {
        requestData.accessLevel = accessLevel
      }

      const { data } = await axios.put(`${host}/service/channel/v2/channel/${channelId}/channel_manager/${channelManagerId}`,
        requestData,
        headers
      )

      dispatch(({ type: actionTypes.UPDATE_CHANNEL_MANAGERS_SUCCESSFUL, payload: data }))

    }
    catch (e) {
      dispatch({ type: actionTypes.UPDATE_CHANNEL_MANAGERS_FAILED, payload: e })

    }

  },

  resetChannelManagersData: () => async (dispatch, getState) => {

    dispatch({ type: actionTypes.RESET_CHANNEL_MANAGERS_DATA })

  },

  updatePlaybackStatus: () => async (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_PLAYBACK_STATUS })
  },

  fetchChannelFeatures: (channelId: number | string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CHANNEL_FEATURE, payload: { channelId } })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/channel/v2/channel/${channelId}/features`, { headers })
      
      dispatch({
        type: actionTypes.FETCH_CHANNEL_FEATURE_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_CHANNEL_FEATURE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  updateChannelFeatures: (channelId: number | string, featureData: any, getFlag: boolean = true) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_CHANNEL_FEATURE })
    
    try {

      const headers: {
        Accept: string,
        withCredentials: boolean
      } = {
        Accept: 'application/json',
        withCredentials: true
      }

      const response = await axios.put(`/service/channel/v2/channel/${channelId}/features`, featureData, { headers })
      
      dispatch({
        type: actionTypes.UPDATE_CHANNEL_FEATURE_SUCCESSFUL,
        payload: response
      })

      if (getFlag) {
        await dispatch(actions.fetchChannelFeatures(channelId))
      }
  
    }

    catch (e) {
      dispatch({ type: actionTypes.UPDATE_CHANNEL_FEATURE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  
  },

  fetchEmailTemplates: (targetId: number | string, type: string, offset?: number , BTSESSION?: string) => (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_EMAIL_TEMPLATES, payload: { targetId } })

      const state = getState()
      let host = ''
      
      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      return new Promise((resolve, reject) => {

        let url: string

        const channelQuery = targetId ? `&targetId=${targetId}` : ''

        if(!offset) {
          url = `${host}/service/email/list?type=${type}${channelQuery}`
        }else {
          url = `${host}/service/email/list?type=${type}${channelQuery}&limit=5&offset=${offset}`
        }

        axios.get(url, { headers })
        .then(response => {

          if(response.status === 200 && offset) {
            dispatch({
              type: actionTypes.FETCH_EMAIL_TEMPLATES_SUCCESSFUL,
              payload: { data: response.data }
            })
            resolve(true)
          }else if(response.status === 200 && !offset) {
            dispatch({
              type: actionTypes.FETCH_ALL_EMAIL_TEMPLATES_SUCCESSFUL
            })
            resolve(response.data)
          }

        })
        .catch(e => {

          dispatch({ type: actionTypes.FETCH_EMAIL_TEMPLATES_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)

        }) 
      })

  },

  deleteEmailTemplate: (data: { id: string }, targetId: string, emailType: string , page: number, BTSESSION?: string) => (dispatch, getState) => {

    dispatch({ type: actionTypes.DELETE_EMAIL_TEMPLATE })

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      return new Promise((resolve, reject) => {

        axios.post(`${host}/service/email/delete`, data, { headers })
        .then(response => {
          if(response.status === 200) {
            dispatch({
              type: actionTypes.DELETE_EMAIL_TEMPLATE_SUCCESSFUL,
              payload: { response }
            })
            return true            
          }
        })
        .then(res => {
          if(res === true) {
            dispatch(actions.fetchEmailTemplates(targetId, getEmailType(emailType), page))
            resolve(true)
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.DELETE_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)
        })

      })

  },

  activateEmailTemplate: (data: { id: string }, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.ACTIVATE_EMAIL_TEMPLATE })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.post(`${host}/service/email/activate`, data, { headers })
      
      dispatch({
        type: actionTypes.ACTIVATE_EMAIL_TEMPLATE_SUCCESSFUL,
        payload: { response }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.ACTIVATE_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  deactivateEmailTemplate: (data: { id: string } , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.DEACTIVATE_EMAIL_TEMPLATE })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.post(`${host}/service/email/deactivate`, data, { headers })
      
      dispatch({
        type: actionTypes.DEACTIVATE_EMAIL_TEMPLATE_SUCCESSFUL,
        payload: { response }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.DEACTIVATE_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  createEmailTemplate: (data: { type: string, name: string, subject: string, targetId?: number | string, templateType: string, HTMLContent: string, textContent: string, logo?:Blob }, channelData?:any , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({type: actionTypes.SUBMIT_EMAIL_TEMPLATE})
    dispatch({ type: actionTypes.CREATE_EMAIL_TEMPLATE })
    
    const blob:Blob | undefined = data?.logo
    delete data.logo

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      if(data.templateType.toLowerCase() === "basic" && blob && channelData){
          await actions.uploadCompanyLogo(dispatch, getState, blob, channelData, data)
      }

      const response = await axios.post(`${host}/service/email/save`, data, { headers })
      
      await dispatch({
        type: actionTypes.CREATE_EMAIL_TEMPLATE_SUCCESSFUL,
        payload: { data: response.data }
      })
      dispatch({type: actionTypes.SUBMIT_EMAIL_TEMPLATE_SUCCESS})
  
    }

    catch (e) {
      console.log(e)
      dispatch({ type: actionTypes.CREATE_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }

  },

  getEmailTemplate: (emailId: number , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.GET_EMAIL_TEMPLATE })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/email/${emailId}`, { headers })
      
      dispatch({
        type: actionTypes.GET_EMAIL_TEMPLATE_SUCCESSFUL,
        payload: { data:  response.data }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.GET_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  updateEmailTemplate: (emailId: string, data: { id: string, type: string, templateType: string, isCurrent: string, beenCurrent: string, name: string, subject: string, targetId?: string, HTMLContent: string, textContent: string, logo?: Blob },channelData?: any,BTSESSION?: string) => async (dispatch, getState) => {

    const blob:Blob| undefined = data?.logo
    delete data.logo
    dispatch({type: actionTypes.SUBMIT_EMAIL_TEMPLATE})
    dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE })
    
    try {
      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      if(data.templateType.toLowerCase() === "basic" && blob && channelData){

        await actions.uploadCompanyLogo(dispatch, getState, blob, channelData, data)
      }

      const response = await axios.post(`${host}/service/email/save/${emailId}`, data, { headers })
      
      dispatch({
        type: actionTypes.UPDATE_EMAIL_TEMPLATE_SUCCESSFUL,
        payload: { response }
      })

      dispatch({type: actionTypes.SUBMIT_EMAIL_TEMPLATE_SUCCESS})
  
    }

    catch (e) {
      dispatch({ type: actionTypes.UPDATE_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }

  },

  async uploadCompanyLogo(dispatch, getState, blob: Blob, channelData: any, data: any){
      interface LinkItem {
        href: string
        title: string
      }
      
      const uploadedImage = await dispatch(actions.postBasicTemplateSubmit(blob, channelData))

      if(uploadedImage && uploadedImage.length > 0){
        const updatedLinks : Array<LinkItem> = channelData.links ? channelData.links : []

        const existingLogoLink = updatedLinks.find(x=>x.title === "logo") 
        
        if(existingLogoLink){
          updatedLinks.forEach(lnk => {
           if(lnk.title==='logo'){
              lnk.href = uploadedImage
            }
          });
        } 
        else{
          updatedLinks.push({
            href:uploadedImage,
            title: "logo"
          })
        }

        await dispatch(actions.updateChannelData(channelData.id, {
          id: channelData.id,
          links: updatedLinks,
          searchVisibility: channelData.searchVisibility
        }))

      }
  },

  sendPreviewTemplate: (data: { id: string, recipient: string }, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.SEND_PREVIEW_TEMPLATE })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.post(`${host}/service/email/previewsend`, data, { headers })
      
      dispatch({
        type: actionTypes.SEND_PREVIEW_TEMPLATE_SUCCESSFUL,
        payload: { response }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.SEND_PREVIEW_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  getBasicEmailTemplate: (basicEmailType: string , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.GET_BASIC_EMAIL_TEMPLATE })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
        'Cache-Control': string
      } = {
        Accept: 'application/json',
        'Cache-Control': 'max-age=0'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

     const response = await axios.get(`${host}/service/email/basic?type=${basicEmailType}`, { headers })
     
      dispatch({
        type: actionTypes.GET_BASIC_EMAIL_TEMPLATE_SUCCESSFUL,
        payload: { data:  response.data       
        }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.GET_BASIC_EMAIL_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  getEmailPreviewTemplate: (emailId: number , BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.GET_EMAIL_PREVIEW_TEMPLATE })
    
    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean,
        'Cache-Control': string
      } = {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/email/preview/${emailId}`, { headers })
      
      dispatch({
        type: actionTypes.GET_EMAIL_PREVIEW_TEMPLATE_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.GET_EMAIL_PREVIEW_TEMPLATE_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  setPreviewTemplateStatus: () => async (dispatch) => {
    dispatch({ type: actionTypes.SET_PREVIEW_TEMPLATE_STATUS_DEFAULT })
  },

  fetchUsersList: (body, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_USERS_LIST })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
        Authorization?: string
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.post(`${host}/service/user/v2/users`, { ...body }, { headers })

      dispatch({
        type: actionTypes.FETCH_USERS_LIST_SUCCESSFUL,
        payload: { data: response.data.users, total: response.data.total }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.FETCH_USERS_LIST_FAILED, payload: { error: JSON.stringify(e) } })
    }
  
  },

  resetUsersList: () => async (dispatch) => {

    dispatch({ type: actionTypes.RESET_USERS_LIST })

  },
  
  fetchEmailPreferences: (userId: string, BTSESSION?: string, accordionFlag?: boolean) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_EMAIL_PREFERENCES, accordionFlag: accordionFlag })

    try {
      
      const state = getState()
      let host = ''
      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean,
        'Content-Type': string,
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }
      
      const response = await axios.get(`${host}/service/user/v1/user/preferences?userId=${userId}`, { headers })

      dispatch({
        type: actionTypes.FETCH_EMAIL_PREFERENCES_SUCCESSFUL,
        payload: { data: response.data.preferences }
      })

    }
    catch (e) {
      console.log(e)
      dispatch({ type: actionTypes.FETCH_EMAIL_PREFERENCES_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },
  
  fetchUserRoles: (userId: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_USER_ROLES })

    try {
      
      const state = getState()
      let host = ''
      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean,
        'Content-Type': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }
      
      const response = await axios.get(`${host}/service/user/user/${userId}/roles`, { headers })
  
      dispatch({
        type: actionTypes.FETCH_USER_ROLES_SUCCESSFUL,
        payload: { data: response.data }
      })

    }
    catch (e) {
      dispatch({ type: actionTypes.FETCH_USER_ROLES_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },
  
  updateUserRoles: (userId: string, roleName: string, requestType: string, BTSESSION?: string) => (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_USER_ROLES })
      
    const state = getState()
    let host = ''
    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean,
      'Content-Type': string
    } = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {
      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host
    } else {
      headers.withCredentials = true
    }

    if(requestType === 'add') {

      return new Promise((resolve, reject) => {

        axios.put(`${host}/service/user/user/${userId}/role/${roleName}`, { headers })
        .then(response => {
          if(response.status === 200) {
            dispatch({
              type: actionTypes.UPDATE_USER_ROLES_SUCCESSFUL,
              payload: { response }
            })
            resolve(true)            
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.UPDATE_USER_ROLES_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)
        })

      })

    }else if(requestType === 'revoke'){

      return new Promise((resolve, reject) => {

        axios.delete(`${host}/service/user/user/${userId}/role/${roleName}`, { headers })
        .then(response => {
          if(response.status === 200) {
            dispatch({
              type: actionTypes.UPDATE_USER_ROLES_SUCCESSFUL,
              payload: { response }
            })
            resolve(true)          
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.UPDATE_USER_ROLES_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)
        })

      })
    }
  },

  fetchRealms: (BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_REALMS })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {
        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host
      } else {
        headers.withCredentials = true
      }

      const response = await axios.get(`${host}/service/user/realms`, { headers })

      
      dispatch({
        type: actionTypes.FETCH_REALMS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.FETCH_REALMS_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  createRealms: (data: any) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CREATE_REALMS })

    try {

      const state = getState()
      const host = ''

      const headers: {
        Accept: string,
        'Content-Type': string;
        charset?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'charset': 'utf-8',
        withCredentials: true
      }

      const response = await axios.post(`${host}/service/user/realm`, data, { headers })

      
      dispatch({
        type: actionTypes.CREATE_REALMS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      const errorResponse = JSON.parse(JSON.stringify(e.response))
      let error = { message: '' }
      if (errorResponse && errorResponse.data) {
        error = errorResponse.data
      }
      dispatch({ type: actionTypes.CREATE_REALMS_FAILED, payload: { error: error.message } })
      debug(e)
    }
  },

  updateRealms: (realmId: string, data: any) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_REALMS })

    try {

      const headers: {
        Accept: string,
        'Content-Type': string;
        charset?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'charset': 'utf-8',
        withCredentials: true
      }

      const response = await axios.put(`/service/user/realm/${realmId}`, data, { headers })

      
      dispatch({
        type: actionTypes.UPDATE_REALMS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      const errorResponse = JSON.parse(JSON.stringify(e.response))
      let error = { message: '' }
      if (errorResponse && errorResponse.data) {
        error = errorResponse.data
      }
      dispatch({ type: actionTypes.UPDATE_REALMS_FAILED, payload: { error: error.message } })
      debug(e)
    }
  },

  getRealmById: (id: string, invalidRealmIdCallback?: () => void) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.GET_REALM_BY_ID })

    try {

      const headers: {
        Accept: string,
        'Content-Type': string;
        charset?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'charset': 'utf-8',
        withCredentials: true
      }

      const response = await axios.get(`/service/user/realm/${id}`, { headers })

      
      dispatch({
        type: actionTypes.GET_REALM_BY_ID_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      if (has(e, 'response')) {
        const errorResponse = JSON.parse(JSON.stringify(e.response))
        if (errorResponse && errorResponse.data &&
            (errorResponse.data.code === 'InvalidRealmId' || errorResponse.data.code === 'RealmNotFound') && invalidRealmIdCallback) {
          invalidRealmIdCallback()
        }
      }
      dispatch({ type: actionTypes.GET_REALM_BY_ID_FAILED, payload: { error: 'FAILED' } })
      debug(e)
    }
  },

  deleteUser: (id: string |  number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.DELETE_USER })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
        'BrightTALK-API-Client'?: string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      await axios.delete(`${host}/service/user/v1/user/${id}`, { headers })
      
      dispatch({
        type: actionTypes.DELETE_USER_SUCCESSFUL,
        payload: 'successful'
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.DELETE_USER_FAILED, payload: 'failed' })
    }
  },
  
  resetUserPassword: (userId: string, passwordData: { newPassword: string }, BTSESSION?: string) => (dispatch, getState) => {

    dispatch({ type: actionTypes.RESET_USER_PASSWORD })
      
    const state = getState()
    let host = ''
    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean,
      'BrightTALK-API-Client': string
    } = {
      Accept: 'application/json',
      'BrightTALK-API-Client': 'brighttalk-central'
    }

    if (BTSESSION) {
      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host
    } else {
      headers.withCredentials = true
    }

    return new Promise((resolve, reject) => {

      axios.put(`${host}/service/user/v1/user/${userId}/password`, passwordData, { headers })
        .then(response => {
          if (response.status === 204) {
            dispatch({
              type: actionTypes.RESET_USER_PASSWORD_SUCCESSFUL,
              payload: { response }
            })
            resolve(true)
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.RESET_USER_PASSWORD_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)
        })

    })

  },
  fetchAllCommunities: (BTSESSION?: string, query = true) => async (dispatch, getState) => {
    const state = getState()
    let allCommunities
    dispatch({ type: actionTypes.FETCH_ALL_COMMUNITIES })

    try {

      allCommunities = await communities.getAllCommunities(state.config.host, BTSESSION, query)
      if (allCommunities) {
        dispatch({
          type: actionTypes.FETCH_ALL_COMMUNITIES_SUCCESSFUL,
          payload: { allCommunities: allCommunities.communities || [] }
        })
      } else {
        dispatch({ type: actionTypes.FETCH_ALL_COMMUNITIES_FAILED })        
      }
    }
    catch (e) {
      dispatch({ type: actionTypes.FETCH_ALL_COMMUNITIES_FAILED, payload: e.message })
    }
  },

  updateChannelCommunities: (channelId, communitiesArr) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.SUBMITING_COMMUNITIES })
    const state = getState()

    await communities.setChannelCommunities(channelId, communitiesArr)

    dispatch({ type: actionTypes.SUBMITING_COMMUNITIES_SUCCESS })

  },
  fetchUserProfileDetails: (userId: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_USERS_PROFILE_DETAILS, payload: { userId } })

    try {
      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean,
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/user/v1/user/${userId}/profile`, { headers })

      dispatch({
        type: actionTypes.FETCH_USERS_PROFILE_DETAILS_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_USERS_PROFILE_DETAILS_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },
  
  updateEmailPreferences: (preferencesData: any, BTSESSION?: string, accordionFlag?: boolean) => (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_EMAIL_PREFERENCES, accordionFlag: accordionFlag })
      
    const state = getState()
    let host = ''
    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean,
      'Content-Type': string,
      'BrightTALK-API-Client': string
    } = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'BrightTALK-API-Client': 'brighttalk-central'
    }

    if (BTSESSION) {
      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host
    } else {
      headers.withCredentials = true
    }

    return new Promise((resolve, reject) => {

      axios.put(`${host}/service/user/v1/users/preferences`, preferencesData, { headers })
        .then(response => {
          if (response.status === 200) {
            dispatch({
              type: actionTypes.UPDATE_EMAIL_PREFERENCES_SUCCESSFUL,
              payload: { response }
            })
            resolve(true)
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.UPDATE_EMAIL_PREFERENCES_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)
        })

    })

  },
  fetchWebcastSelectionCommunications: (identifier, params, merge, BTSESSION?: string) => (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_COMMUNICATIONS, payload: { identifier } })

    interface CommunicationSearch {
      channel?,
      offset?,
      sort?,
      limit?,
      providers?,
      status?,
      publishStatus?,
      visibilities?,
      includeCategories?,
      includeSyndicationDetails?,
      ids?,
      phrase?,
      time?,
      syndication?,
      excludedChannels?
    }

    const data: CommunicationSearch = { }

    if (params.channelId) {
      data.channel = {
        id: params.channelId
      }
    }

    if (params.excludedChannels) {

      data.excludedChannels = params.excludedChannels

    }

    if (params.offset >= 0) {

      data.offset = params.offset

    }

    if (params.sortOrder && params.sortName) {

      data.sort = {
        order: params.sortOrder,
        name: params.sortName
      }

    }

    if (params.limit) {

      data.limit = params.limit

    }

    if (params.providers) {

      data.providers = params.providers

    }

    if (params.status) {

      data.status = params.status

    }

    if (params.publishStatus) {

      data.publishStatus = params.publishStatus

    }

    if (params.visibilities) {

      data.visibilities = params.visibilities

    }

    if (params.includeCategories !== undefined && params.includeCategories !== null) {

      data.includeCategories = params.includeCategories

    }

    if (params.includeSyndicationDetails !== undefined && params.includeSyndicationDetails !== null) {

      data.includeSyndicationDetails = params.includeSyndicationDetails

    }

    if (params.limit) {

      data.limit = params.limit

    }

    if (params.ids && params.ids.length > 0) {

      data.ids = params.ids

    }

    if (params.query && params.query.length > 0) {

      data.phrase = params.query

    }

    if (params.startTime || params.endTime) {

      data.time = {
        start: params.startTime,
        end: params.endTime
      }

    }

    if (params.syndicationType || params.syndicationAuthorisation) {

      data.syndication = { 
        type: params.syndicationType,
        authorisation: params.syndicationAuthorisation
      }

    }

      const headers: {
        Accept: string,
        Cookie?: string
      } = {
        Accept: 'application/json'
      }
  
      const state = getState()
      let host = ''

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + BTSESSION
  
        if (state && state.config && state.config.host) {
  
          host = state.config.host
        }
  
      }

      return new Promise((resolve, reject) => {

        axios.post(`${host}/service/communication/v1/communications`, data, { headers })
          .then(res => {
            if (res.status === 200) {
              dispatch({
                type: actionTypes.FETCH_COMMUNICATIONS_SUCCESS,
                payload: { ...res.data, identifier, merge, offset: params.offset, limit: params.limit }
              })
              resolve(res.data)
            }
          })
          .catch(e => {
            dispatch({ type: actionTypes.FETCH_COMMUNICATIONS_FAILED, payload: { data: e, identifier } })
            resolve(false)
          })
  
      })
  },

  fetchCategories: (channelId: string, sortBy: string, sortByOrder: string, page?: number, pageSize?: number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CATEGORIES })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
        Authorization?: string
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const params = `?page=${page || 1}&pageSize=${pageSize || 6}${sortBy ? `&sortBy=${sortBy}` : ''}${sortByOrder ? `&sortOrder=${sortByOrder}` : ''}`

      const response = await axios.get(`${host}/service/channel/v2/channel/${channelId}/categories${params}`, { headers })

      dispatch({
        type: actionTypes.FETCH_CATEGORIES_SUCCESSFUL,
        payload: { data: response.data, total: response.data.total }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.FETCH_CATEGORIES_FAILED, payload: { error: JSON.stringify(e) } })
    }
  
  },

  addCategory: (channelId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.ADD_CATEGORY })


    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean
      Authorization?: string
      'BrightTALK-API-Client': string
    } = {
      Accept: 'application/json',
      'BrightTALK-API-Client': 'brighttalk-central'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    } else {

      headers.withCredentials = true

    }

    const response: any = []
    const error: any = []
    

    await Promise.all(data.map(async (item) => {

      try {

        item.type = item.type.trim()
        item.subtype = item.subtype.trim()
        const res = await axios.post(`${host}/service/channel/v2/channel/${channelId}/category`, { ...item }, { headers })
        response.push(res)

      } catch (e) {

        error.push(item)

      }

    }))

    if (data.length === error.length) {

      status = 'FAILED'

    } else if (data.length > response.length) {

      status = 'PARTIAL'

    }

    dispatch({
      type: status === 'SUCCESS' ? actionTypes.ADD_CATEGORY_SUCCESSFUL : actionTypes.ADD_CATEGORY_FAILED,
      payload: { status }
    })
  
  },

  deleteCategory: (channelId: string, id: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.DELETE_CATEGORY })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
        Authorization?: string
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      await axios.delete(`${host}/service/channel/v2/channel/${channelId}/category/${id}`, { headers })

      dispatch({
        type: actionTypes.DELETE_CATEGORY_SUCCESSFUL,
        payload: { status: 'SUCCESSFUL' }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.DELETE_CATEGORY_FAILED, payload: { error: JSON.stringify(e), status: 'FAILED' } })
    }
  
  },

  updateCategory: (channelId: string, id: string, body: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_CATEGORY })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
        Authorization?: string
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      body.type = body.type.trim()
      body.subtype = body.subtype.trim()
      const response = await axios.put(`${host}/service/channel/v2/channel/${channelId}/category/${id}`, { ...body }, { headers })

      dispatch({
        type: actionTypes.UPDATE_CATEGORY_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.UPDATE_CATEGORY_FAILED, payload: { error: JSON.stringify(e) } })
    }
  
  },

  fetchEmailTypes: (BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_EMAIL_TYPES })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/email/list`, { headers })

      dispatch({
        type: actionTypes.FETCH_EMAIL_TYPES_SUCCESSFUL,
        payload: { data: response.data.email, total: response.data.total }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.FETCH_EMAIL_TYPES_FAILED, payload: { error: JSON.stringify(e) } })
    }
  
  },

  updateProfileDetails: (userId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_PROFILE_DETAILS, payload: { userId } })

    try {
      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean,
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.put(`${host}/service/user/v1/user/${userId}/profile`, data, { headers })

      dispatch({
        type: actionTypes.UPDATE_PROFILE_DETAILS_SUCCESSFUL,
        payload: { data: response.data }
      })
  
    }

    catch (e) {

      dispatch({ type: actionTypes.UPDATE_PROFILE_DETAILS_FAILED, payload: { error: JSON.stringify(e) } })
    }
  },

  createPrimaryCommunity: (data: any, BTSESSION?: string) => async (dispatch, getState) => {

      dispatch({ type: actionTypes.CREATE_PRIMARY_COMMUNITY })

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      return new Promise((resolve, reject) => {

        axios.post(`${host}/service/community/v1/category`, data, { headers })
          .then(response => {
            if (response.status === 201) {
              dispatch({
                type: actionTypes.CREATE_PRIMARY_COMMUNITY_SUCCESSFUL,
                payload: { data: response }
              })
              resolve(true)
            }
          })
          .catch(e => {
            if (e && e.response && e.response.status === 400) {
              if (e.response.data && e.response.data.code) {
                resolve(e.response.data)
              } else {
                resolve(false)
              }
            } else {
              resolve(false)
            }
            dispatch({ type: actionTypes.CREATE_PRIMARY_COMMUNITY_FAILED, payload: { error: JSON.stringify(e) } })
            
          })
  
      })
  
  },

  fetchCommunity: (communityId: string, query: string, BTSESSION?: string) => async (dispatch, getState) => {

    if(query === 'primary') {
      dispatch({ type: actionTypes.FETCH_PRIMARY_COMMUNITY })
    }else {
      dispatch({ type: actionTypes.FETCH_SUB_COMMUNITY })
    }

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      const response = await axios.get(`${host}/service/community/v1/category/${communityId}`, { headers })

      if(query === 'primary') {
        dispatch({
          type: actionTypes.FETCH_PRIMARY_COMMUNITY_SUCCESSFUL,
          payload: { data: response.data }
        })
      }else {
        dispatch({
          type: actionTypes.FETCH_SUB_COMMUNITY_SUCCESSFUL,
          payload: { data: response.data }
        })
      }
  
    }

    catch (e) {
      
      if(query === 'primary') {
        dispatch({ type: actionTypes.FETCH_PRIMARY_COMMUNITY_FAILED, payload: { error: JSON.stringify(e) } })
      }else {
        dispatch({ type: actionTypes.FETCH_SUB_COMMUNITY_FAILED, payload: { error: JSON.stringify(e) } })
      }

    }
  
  },

  updatePrimaryCommunity: (communityId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_PRIMARY_COMMUNITY })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean
    } = {
      Accept: 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    } else {

      headers.withCredentials = true

    }

    return new Promise((resolve, reject) => {

      axios.put(`${host}/service/community/v1/category/${communityId}`, data, { headers })
        .then(response => {
          if (response.status === 200) {
            dispatch({
              type: actionTypes.UPDATE_PRIMARY_COMMUNITY_SUCCESSFUL,
              payload: { data: response }
            })
            resolve(true)
          }
        })
        .catch(e => {
          if (e && e.response && e.response.status === 400) {
            if (e.response.data && e.response.data.code) {
              resolve(e.response.data)
            } else {
              resolve(false)
            }
          } else {
            resolve(false)
          }
          dispatch({ type: actionTypes.UPDATE_PRIMARY_COMMUNITY_FAILED, payload: { error: JSON.stringify(e) } })
          
        })

    })

  },

  deleteCommunity: (categoryId: string, BTSESSION?: string) => (dispatch, getState) => {

    dispatch({ type: actionTypes.DELETE_COMMUNITY })

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      return new Promise((resolve, reject) => {

        axios.delete(`${host}/service/community/v1/category/${categoryId}`, { headers })
        .then(response => {
          if(response.status === 204) {
            dispatch({
              type: actionTypes.DELETE_COMMUNITY_SUCCESSFUL,
              payload: { response }
            })
            resolve(true)            
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.DELETE_COMMUNITY_FAILED, payload: { error: JSON.stringify(e) } })
          resolve(false)
        })

      })

  },

  fetchSubCommunities: (categoryId: string, page: number, pageSize: number, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SUB_COMMUNITIES })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      Cookie?: string,
      withCredentials?: boolean
    } = {
      Accept: 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    } else {

      headers.withCredentials = true

    }


      axios.get(`/service/community/v1/category/${categoryId}/subcommunities?page=${page}&pageSize=${pageSize}`, { headers })
        .then(response => {

          dispatch({
            type: actionTypes.FETCH_SUB_COMMUNITIES_SUCCESSFUL,
            payload: { data: response.data }
          })

        }).catch(e => {

          dispatch({ type: actionTypes.FETCH_SUB_COMMUNITIES_FAILED, payload: { error: JSON.stringify(e) } })
          
        })


  },

  decryptRealmToken: (data: string, urlEncoded: boolean) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.DECRYPT_REALM_TOKEN })

    try {

      const headers: {
        'Content-Type': string
        withCredentials: boolean
      } = {
        'Content-Type': !urlEncoded ? 'application/vnd.brighttalk.realmtoken' : 'application/vnd.brighttalk.realmtoken.urlencoded',
        withCredentials: true
      }

      const response = await axios.post(`/service/user/realm/token`, data, { headers })

      dispatch({
        type: actionTypes.DECRYPT_REALM_TOKEN_SUCCESSFUL,
        payload: { data: typeof response.data === 'object' ? JSON.stringify(response.data) : response.data }
      })

    }

    catch (e) {

      let errMsg = ''

      if (e && e.response && e.response.status === 400) {
        if (e.response.data && e.response.data.code 
            && e.response.data.code === 'InvalidFormatRealmToken') {
          
              errMsg = e.response.data.message

        }
      }

      dispatch({ type: actionTypes.DECRYPT_REALM_TOKEN_FAILED, payload: { error: JSON.stringify(e), errMsg: errMsg } })
      debug(e)

    }
  },
  generateRealmToken: (id: string, data: string, checked: boolean) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.GENERATE_REALM_TOKEN })

    try {

      const headers: {
        Accept: string,
        'Content-Type': string;
        charset?: string,
        withCredentials?: boolean
      } = {
        Accept: checked ? 'application/vnd.brighttalk.realmtoken.urlencoded' : 'application/vnd.brighttalk.realmtoken',
        'Content-Type': 'text/plain',
        'charset': 'utf-8',
        withCredentials: true
      }

      const response = await axios.post(`/service/user/realm/${id}/token`, data, { headers })

      
      dispatch({
        type: actionTypes.GENERATE_REALM_TOKEN_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      dispatch({ type: actionTypes.GENERATE_REALM_TOKEN_FAILED, payload: { error: 'FAILED' } })
      debug(e)
    }
  },

  regenerateInitVector: (id: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.REGENERATE_INIT_VECTOR })

    try {

      const headers: {
        Accept: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        withCredentials: true
      }

      const response = await axios.post(`/service/user/realm/${id}/init_vector`, '', { headers })

      dispatch({
        type: actionTypes.REGENERATE_INIT_VECTOR_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      dispatch({ type: actionTypes.REGENERATE_INIT_VECTOR_FAILED, payload: { error: JSON.stringify(e) } })
      debug(e)
    }
  },

  regenerateEncryptionKey: (id: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.REGENERATE_ENCRYPTION_KEY })

    try {

      const headers: {
        Accept: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        withCredentials: true
      }

      const response = await axios.post(`/service/user/realm/${id}/aes128key`, '', { headers })

      dispatch({
        type: actionTypes.REGENERATE_ENCRYPTION_KEY_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      dispatch({ type: actionTypes.REGENERATE_ENCRYPTION_KEY_FAILED, payload: { error: JSON.stringify(e) } })
      debug(e)
    }
  },
  createChannel: (data: any) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CREATE_CHANNEL })

    try {

      const host = ''
      const headers: {
        Accept: string,
        'Content-Type': string;
        charset?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'charset': 'utf-8',
        withCredentials: true
      }

      const response = await axios.post(`${host}/service/channel/v2/channel`, data, { headers })

      
      dispatch({
        type: actionTypes.CREATE_CHANNEL_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {
      let errMsg = ''
      if (e.response.data && e.response.data.code 
          && e.response?.data?.message) {
            errMsg = e.response.data.message
      }
      dispatch({ type: actionTypes.CREATE_CHANNEL_FAILED, payload: { error: errMsg } })
      debug(e)
    }
  },

  fetchSummitsList: (data, page, pageSize, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SUMMITS_LIST })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        withCredentials?: boolean
        Cookie?: string
        'BrightTALK-API-Client': string
        'Content-Type': string
      } = {
        Accept: 'application/json',
        withCredentials: true,
        'BrightTALK-API-Client': 'brighttalk-central',
        'Content-Type': 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.post(`${host}/service/summit/v3/summits?pageSize=${pageSize}&page=${page || 1}`, { ...data }, { headers })
      dispatch({
        type: actionTypes.FETCH_SUMMITS_LIST_SUCCESSFUL,
        payload: { data: response.data.summits, total: response.data.total }
      })
  
    }

    catch (e) {
      debug(e)
      dispatch({ type: actionTypes.FETCH_SUMMITS_LIST_FAILED, payload: { error: JSON.stringify(e) } })
    }
  
  },

  resetSummitList: () => async (dispatch) => {

    dispatch({ type: actionTypes.RESET_SUMMITS_LIST })

  },

  createVirtualEvent: (formData) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CREATE_VIRTUAL_EVENT, payload: formData })
    const state = getState()
    let newVirtualEvent
    let flag = true

    try {

      const { data } = await virtualEventServices.post({ ...formData })
      newVirtualEvent = data

    }
    catch (e) {

      if (has(e, 'response.data')) {

        flag = false
        dispatch({ type: actionTypes.CREATE_VIRTUAL_EVENT_ERROR, payload: e.response.data })

      }

    }

    if (flag) {

      if (newVirtualEvent) {

        dispatch({type: actionTypes.CREATE_VIRTUAL_EVENT_SUCCESS, payload: newVirtualEvent})

      } else {

        dispatch({ type: actionTypes.CREATE_VIRTUAL_EVENT_ERROR, payload: {code: 'error', message: 'Failed to create'} })

      }

    }

  },

  resetCreateVirtualEvent: () => ({ type: actionTypes.RESET_CREATE_VIRTUAL_EVENT, payload: null }),

  fetchVirtualEvent: (eventId: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SUMMIT_EVENT, payload: {} })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        withCredentials?: boolean
        Cookie?: string,
        'BrightTALK-API-Client': string
        'Content-Type': string
      } = {
        Accept: 'application/json',
        withCredentials: true,
        'BrightTALK-API-Client': 'brighttalk-central',
        'Content-Type': 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.get(`${host}/service/summit/v3/summit/${eventId}` , { headers })

      dispatch({
        type: actionTypes.FETCH_SUMMIT_EVENT_SUCCESSFUL,
        payload: { data: response.data }
      })

    }
    catch (e: any) {
      
      debug(e)
      if (has(e, 'response.data')) {
        dispatch({ type: actionTypes.FETCH_SUMMIT_EVENT_FAILED, payload: { error: e.response.data } })
      } else {
        dispatch({ type: actionTypes.FETCH_SUMMIT_EVENT_FAILED, payload: { error: JSON.stringify(e) } })
      }

    }

  },

  updateVirtualEvent: (eventId, formData, eventData: any = {}, updateOnly = false) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_VIRTUAL_EVENT, payload: formData })

    const state = getState()
    let virtualEventData
    let flag = true

    try {

      if (!updateOnly) {

        const faviconBlob: Blob | undefined = formData?.faviconLink
        const companyLogoBlob: Blob | undefined = formData?.companyLogo
        const heroImageBlob: Blob | undefined = formData?.imageUrl
        const socialMediaLogoBlob: Blob | undefined = formData?.socialMediaLogo

        const uploadedImage = await dispatch(actions.uploadVirtualEventImages({faviconBlob, companyLogoBlob, heroImageBlob, socialMediaLogoBlob}, eventId, formData.accountId))

        if (!isEmpty(uploadedImage)) {
          const faviconLink =  uploadedImage.find(imageType => Object.keys(imageType)[0] === "favicon")
          const companyLogoLink = uploadedImage.find(imageType => Object.keys(imageType)[0] === "companyLogo")
          const imageUrl = uploadedImage.find(imageType => Object.keys(imageType)[0] === "heroImage")
          const socialMediaLogoLink = uploadedImage.find(imageType => Object.keys(imageType)[0] === "socialMedia")

          formData.faviconLink = formData.faviconLink === 'deleted' ? "" : faviconLink?.favicon?.url || eventData.faviconLink
          formData.companyLogo = formData.companyLogo === 'deleted' ? "" : companyLogoLink?.companyLogo?.url || eventData.companyLogo
          formData.imageUrl = formData.imageUrl === 'deleted' ? "" : imageUrl?.heroImage?.url || eventData.imageUrl
          formData.socialMediaLogo = formData.socialMediaLogo === 'deleted' ? "" : socialMediaLogoLink?.socialMedia?.url || eventData.socialMediaLogo
        }

      }

      const { data } = await virtualEventServices.update(eventId, formData)
      virtualEventData = data

    } catch (error: any) {

      console.log(error, "---error----")

      if (has(error, 'response.data')) {
        flag = false
        dispatch({ type: actionTypes.UPDATE_VIRTUAL_EVENT_ERROR, payload: error.response.data })
      }

    }

    if (flag) {

      if (virtualEventData) {

        dispatch({ type: actionTypes.UPDATE_VIRTUAL_EVENT_SUCCESS, payload: virtualEventData })

      } else {

        dispatch({ type: actionTypes.UPDATE_VIRTUAL_EVENT_ERROR, payload: { code: 'error', message: 'Failed to update' } })

      }

    }

  },

  resetUpdateVirtualEvent: () => ({ type: actionTypes.RESET_UPDATE_VIRTUAL_EVENT, payload: null }),

  clearVirtualEventServerError: id => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CLEAR_VIRTUAL_EVENT_SERVER_ERROR, payload: id })

  },

  uploadVirtualEventImages: (imageFiles: { faviconBlob?: Blob, companyLogoBlob?: Blob, heroImageBlob?: Blob, socialMediaLogoBlob?: Blob }, eventId: string, accountId: number) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.POST_VIRTUAL_EVENT_IMAGES_CREATION })

    const promise: any = []
    let uploadedCdnUrls = {}

    if (imageFiles.faviconBlob) {
      promise.push(await actions.imageUpload(imageFiles.faviconBlob, eventId, accountId, 'favicon', dispatch, getState))
    }

    if (imageFiles.companyLogoBlob) {
      promise.push(await actions.imageUpload(imageFiles.companyLogoBlob, eventId, accountId, 'companyLogo', dispatch, getState))
    }

    if (imageFiles.heroImageBlob) {
      promise.push(await actions.imageUpload(imageFiles.heroImageBlob, eventId, accountId, 'heroImage', dispatch, getState))
    }

    if (imageFiles.socialMediaLogoBlob) {
      promise.push(await actions.imageUpload(imageFiles.socialMediaLogoBlob, eventId, accountId, 'socialMedia', dispatch, getState))
    }

    await Promise.all(promise).then(values => {

      dispatch({ type: actionTypes.POST_VIRTUAL_EVENT_IMAGES_CREATION_SUCCESS })

      if (values && values.length) {
        uploadedCdnUrls = values
      }

    }). catch((e) => {

      dispatch({ type: actionTypes.POST_VIRTUAL_EVENT_IMAGES_CREATION_FAILED })

    })

    return uploadedCdnUrls

  },

  async imageUpload(blob: Blob, eventId, accountId, imageType, dispatch, getState) {

    const uploader = await BTUploader.initialise({
      'browse_button': document.createElement('div'),
      uploadOnly: true
    })
    let imageUrl = {}

    return new Promise((resolve, reject) => {

      if (!(blob instanceof Blob)) {
        // reject('not an blob')
        resolve(false)
      }

      const type = imageType === 'favicon' ? 'FAVICON' : imageType === 'companyLogo' ? 'COMPANY_LOGO' : imageType === 'heroImage' ? 'HERO_IMAGE' : 'SOCIAL_MEDIA'

      uploader.on(BTUploader.FILE_UPLOADED, async (file, resp) => {

        if(has(resp, 'source.location')) {
          imageUrl[imageType] = {
            url: resp.source.location
          }
        }

        resolve(imageUrl)

        const actionType = 'VIRTUAL_EVENT_' + type + '_UPLOAD_SUCCESS'

        dispatch({ type: actionType })

      })

      uploader.on(BTUploader.ERROR, (e) => {

        const actionType = 'VIRTUAL_EVENT_' + type + '_UPLOAD_FAILED'

        dispatch({ type: actionType, payload: e })
        resolve(false)

      })

      try {
        uploader.addFile(blob)
        uploader.start({
          region: "US West (California)",
          type: 'image',
          target: {
            id: eventId,
            type: 'summit'
          }
        })

      } catch (e) {

        const actionType = 'VIRTUAL_EVENT_' + type + '_UPLOAD_FAILED'

        dispatch({ type: actionType, payload: e })
        resolve(false)

      }

    })

  },

  fetchEventCategories: (eventId: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_EVENT_CATEGORIES, payload: {} })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        withCredentials?: boolean
        Cookie?: string,
        'BrightTALK-API-Client': string
        'Content-Type': string
      } = {
        Accept: 'application/json',
        withCredentials: true,
        'BrightTALK-API-Client': 'brighttalk-central',
        'Content-Type': 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.get(`${host}/service/summit/v3/summit/${eventId}/tracks` , {
          headers,
          transformRequest: () => {
            return null
          }
        })

      dispatch({
        type: actionTypes.FETCH_EVENT_CATEGORIES_SUCCESSFUL,
        payload: { data: response.data }
      })

    }
    catch (e: any) {
      
      debug(e)
      if (has(e, 'response.data')) {
        dispatch({ type: actionTypes.FETCH_EVENT_CATEGORIES_FAILED, payload: { error: e.response.data } })
      } else {
        dispatch({ type: actionTypes.FETCH_EVENT_CATEGORIES_FAILED, payload: { error: JSON.stringify(e) } })
      }

    }

  },

  createEventCategory: (eventId: string, data: { name: string }, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CREATE_EVENT_CATEGORY })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    return new Promise((resolve, reject) => {

      axios.post(`${host}/service/summit/v3/summit/${eventId}/track`, data, { headers })
        .then(response => {
          if (response.status === 200) {
            dispatch({
              type: actionTypes.CREATE_EVENT_CATEGORY_SUCCESSFUL,
              payload: { data: response.data }
            })
            resolve(true)
          }
        })
        .catch(e => {

          if (has(e, 'response.data')) {
            dispatch({ type: actionTypes.CREATE_EVENT_CATEGORY_FAILED, payload: { error: e.response.data } })
            resolve(e.response.data)
          } else {
            dispatch({ type: actionTypes.CREATE_EVENT_CATEGORY_FAILED, payload: { error: JSON.stringify(e) } })
            resolve(false)
          }

        })

    })

  },

  updateEventCategory: (eventId: string, trackId: string, data: { name: string }, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_EVENT_CATEGORY })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    return new Promise((resolve, reject) => {

      axios.put(`${host}/service/summit/v3/summit/${eventId}/track/${trackId}`, data, { headers })
        .then(response => {
          if (response.status === 200) {
            dispatch({
              type: actionTypes.UPDATE_EVENT_CATEGORY_SUCCESSFUL,
              payload: { data: response.data }
            })
            resolve(true)
          }
        })
        .catch(e => {

          if (has(e, 'response.data')) {
            dispatch({ type: actionTypes.UPDATE_EVENT_CATEGORY_FAILED, payload: { error: e.response.data } })
            resolve(e.response.data)
          } else {
            dispatch({ type: actionTypes.UPDATE_EVENT_CATEGORY_FAILED, payload: { error: JSON.stringify(e) } })
            resolve(false)
          }

        })

    })

  },

  deleteEventCategory: (eventId: string, trackId: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.DELETE_EVENT_CATEGORY })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    return new Promise((resolve, reject) => {

      axios.delete(`${host}/service/summit/v3/summit/${eventId}/track/${trackId}`, {
        headers,
        transformRequest: () => {
          return null
        }
      })
        .then(response => {
          if (response.status === 204) {
            dispatch({
              type: actionTypes.DELETE_EVENT_CATEGORY_SUCCESSFUL,
              payload: { data: response.data }
            })
            resolve(true)
          }
        })
        .catch(e => {

          if (has(e, 'response.data')) {
            dispatch({ type: actionTypes.DELETE_EVENT_CATEGORY_FAILED, payload: { error: e.response.data } })
            resolve(e.response.data)
          } else {
            dispatch({ type: actionTypes.DELETE_EVENT_CATEGORY_FAILED, payload: { error: JSON.stringify(e) } })
            resolve(false)
          }

        })

    })

  },

  updateWebcastCdnUrls: (data)  => async (dispatch, getState) => {

    dispatch({ type: actionTypes.SUBMIT_WEBCAST_UPDATE_CDN, payload: data })
    const state = getState()

    try {

      const headers: {
        Accept: string,
        'Content-Type': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }

      const response = await axios.put(`/service/communication/v1/channel/${data.channel.id}/communication/${data.id}`, data, { headers })

      dispatch(({ type: actionTypes.SUBMIT_WEBCAST_SUCCESS_EDIT, payload: response.data }))
      await dispatch(actions.fetchWebcastData(data.channel.id, data.id))

    } catch (e) {

      dispatch({ type: actionTypes.SUBMIT_WEBCAST_ERROR, payload: JSON.stringify(e) })

    }

  },

  getContentSummitAssociation: (eventId: string, query: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.GET_CONTENT_SUMMIT_ASSOCIATION, payload: {} })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        withCredentials?: boolean
        Cookie?: string,
        'BrightTALK-API-Client': string
        'Content-Type': string
      } = {
        Accept: 'application/json',
        withCredentials: true,
        'BrightTALK-API-Client': 'brighttalk-central',
        'Content-Type': 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.get(`${host}/service/summit/v3/summit/${eventId}/communications?ids=${query}` , {
          headers,
          transformRequest: () => {
            return null
          }
        })

      dispatch({
        type: actionTypes.GET_CONTENT_SUMMIT_ASSOCIATION_SUCCESSFUL,
        payload: { data: response.data && response.data.communications ? response.data.communications : [] }
      })

    }
    catch (e: any) {
      
      debug(e)
      if (has(e, 'response.data')) {
        dispatch({ type: actionTypes.GET_CONTENT_SUMMIT_ASSOCIATION_FAILED, payload: { error: e.response.data } })
      } else {
        dispatch({ type: actionTypes.GET_CONTENT_SUMMIT_ASSOCIATION_FAILED, payload: { error: JSON.stringify(e) } })
      }

    }

  },

  addContentToSummitTracks: (eventId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.ADD_CONTENT_TO_SUMMIT_TRACKS })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    return new Promise((resolve, reject) => {

      axios.post(`${host}/service/summit/v3/summit/${eventId}/communications`, data, { headers })
        .then(response => {
          if (response.status === 204) {
            dispatch({
              type: actionTypes.ADD_CONTENT_TO_SUMMIT_TRACKS_SUCCESSFUL,
              payload: { data: response.data }
            })
            resolve(true)
          }
        })
        .catch(e => {

          if (has(e, 'response.data')) {
            dispatch({ type: actionTypes.ADD_CONTENT_TO_SUMMIT_TRACKS_FAILED, payload: { error: e.response.data } })
            resolve(e.response.data)
          } else {
            dispatch({ type: actionTypes.ADD_CONTENT_TO_SUMMIT_TRACKS_FAILED, payload: { error: JSON.stringify(e) } })
            resolve(false)
          }

        })

    })

  },

  deleteContentFromSummitTracks: (eventId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.DELETE_CONTENT_FROM_SUMMIT_TRACKS })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    return new Promise((resolve, reject) => {

      axios.delete(`${host}/service/summit/v3/summit/${eventId}/communications`, {
        data,
        headers
      })
        .then(response => {
          if (response.status === 204) {
            dispatch({
              type: actionTypes.DELETE_CONTENT_FROM_SUMMIT_TRACKS_SUCCESSFUL,
              payload: { data: response.data }
            })
            resolve(true)
          }
        })
        .catch(e => {

          if (has(e, 'response.data')) {
            dispatch({ type: actionTypes.DELETE_CONTENT_FROM_SUMMIT_TRACKS_FAILED, payload: { error: e.response.data } })
            resolve(e.response.data)
          } else {
            dispatch({ type: actionTypes.DELETE_CONTENT_FROM_SUMMIT_TRACKS_FAILED, payload: { error: JSON.stringify(e) } })
            resolve(false)
          }

        })

    })

  },

  fetchSummitTrackCommunications: (eventId: string, trackId: string, pageNumber: number, pageSize: number, identifier: string,
    sort?:  { name: string, order: string}, merge = false, BTSESSION?: string, channelId?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_TRACK_COMMUNICATIONS, payload: { identifier } })

    try {

      const state = getState()
      let host = ''

      const headers: {
        Accept: string,
        withCredentials?: boolean
        Cookie?: string,
        'BrightTALK-API-Client': string
        'Content-Type': string
      } = {
        Accept: 'application/json',
        withCredentials: true,
        'BrightTALK-API-Client': 'brighttalk-central',
        'Content-Type': 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      let url = `${host}/service/summit/v3/summit/${eventId}/track/${trackId}/communications?page=${pageNumber}&pageSize=${pageSize}`

      if (channelId) {
        url = url + `&channelId=${channelId}`
      }
      if (sort) {
        url = url + `&sortBy=${sort.name}`
        url = url + `&sortOrder=${sort.order}`
      }

      const response = await axios.get( url, {
          headers,
          transformRequest: () => {
            return null
          }
      })

      dispatch({
        type: actionTypes.FETCH_TRACK_COMMUNICATIONS_SUCCESSFUL,
        payload: { data: response.data, identifier, merge, pageNumber, pageSize }
      })

      return response.data && response.data.communications

    }
    catch (e: any) {

      debug(e)
      dispatch({ type: actionTypes.FETCH_TRACK_COMMUNICATIONS_FAILED, payload: { error:  JSON.stringify(e), identifier } })

      if (e && e.response && e.response.status === 404 && e.response.data && e.response.data.code === 'ResourceNotFound') {
        return 'ResourceNotFound'
      }

    }

  },

  fetchSummitTrackSelectionCommunications: (eventId: string, trackId: string, pageNumber: number, pageSize: number, identifier: string,
    merge = false, sort?:  { name: string, order: string}, BTSESSION?: string, channelId?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_TRACK_COMMUNICATIONS, payload: { identifier } })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    let url = `${host}/service/summit/v3/summit/${eventId}/track/${trackId}/communications?page=${pageNumber}&pageSize=${pageSize}`

    if (channelId) {
      url = url + `&channelId=${channelId}`
    }
    if (sort) {
      url = url + `&sortBy=${sort.name}`
      url = url + `&sortOrder=${sort.order}`
    }

    return new Promise(async (resolve, reject) => {

      await axios.get(url, { 
          headers,
          transformRequest: () => {
            return null
          } 
        }).then(res => {
          if (res.status === 200) {
            dispatch({
              type: actionTypes.FETCH_TRACK_COMMUNICATIONS_SUCCESSFUL,
              payload: { data: res.data, identifier, merge, pageNumber, pageSize }
            })
            resolve(res.data)
          }
        })
        .catch(e => {
          dispatch({ type: actionTypes.FETCH_TRACK_COMMUNICATIONS_FAILED, payload: { error:  JSON.stringify(e), identifier } })
          resolve(false)
        })
    })

  },

  addRemoveTrackCommunications: (eventId: string, trackId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.ADD_REMOVE_TRACK_COMMUNICATIONS })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string,
      withCredentials?: boolean
      Cookie?: string,
      'BrightTALK-API-Client': string
      'Content-Type': string
    } = {
      Accept: 'application/json',
      withCredentials: true,
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }

    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    }

    return new Promise((resolve, reject) => {

      axios.put(`${host}/service/summit/v3/summit/${eventId}/track/${trackId}/communication`, data, { headers })
        .then(response => {
          if (response.status === 204) {
            dispatch({
              type: actionTypes.ADD_REMOVE_TRACK_COMMUNICATIONS_SUCCESSFUL,
              payload: { response }
            })
            resolve('success')
          }
        })
        .catch(e => {

          if (has(e, 'response.data')) {
            dispatch({ type: actionTypes.ADD_REMOVE_TRACK_COMMUNICATIONS_FAILED, payload: { error: e.response.data } })
            resolve(e.response.data)
          } else {
            dispatch({ type: actionTypes.ADD_REMOVE_TRACK_COMMUNICATIONS_FAILED, payload: { error: JSON.stringify(e) } })
            resolve(false)
          }

        })

    })

  },

  setCurrentWebcastChannelId: (channelId, webcastId) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.SET_CURRENT_WEBCAST_CHANNEL_ID, payload: {channelId, webcastId} })

  },

  fetchSummitAudience: (activitiesReqDetails: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_SUMMIT_AUDIENCE })

    const state = getState()
    let host = ''

    const headers: {
      Accept: string
      Cookie?: string
      'BrightTALK-API-Client': string
      'Content-Type': string
      withCredentials?: boolean
    } = {
      Accept: 'application/json',
      'BrightTALK-API-Client': 'brighttalk-central',
      'Content-Type': 'application/json'
    }


    if (BTSESSION) {

      headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
      host = state.config.host

    } else {

      headers.withCredentials = true
      
    }

    const params = activitiesReqDetails

    try {

      const response = await axios.get(`${host}/service/monet/virtualevents-report/audience-listing`,
                        {
                          headers,
                          params
                        })

      dispatch({
        type: actionTypes.FETCH_SUMMIT_AUDIENCE_SUCCESSFUL,
        payload: { 
          data: response.data.audience,
          totalAudience: response.data.total,
          firstActivityDate: response.data.firstActivityDate || ''
        }
      })

    }

    catch(e) {

      dispatch({ type: actionTypes.FETCH_SUMMIT_AUDIENCE_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  generateVirtualEventsReport: (body: any, BTSESSION?: string) => async (dispatch, getState) => {
    const { type, from, to, summitId, categoryId, activities } = body;

    dispatch({
      type: actionTypes.GENERATE_EVENTS_REPORT,
      payload: {
        type,
        from,
        to,
        summitId,
        categoryId,
        ...activities && { activities }
      }
    })

    const data: GenAttendeeListReportReqData | GenActivityLogReportReqData = {
      type: type === 'activity-report' ? 'activity' : type,
      summitId,
      categoryId,
      filters: {
        dateRange: {
          from: from || undefined,
          to: to || undefined,
        },
        ...activities && { activities }
      }
    }

    try {

      const state = getState()
      let host = ''
      
      const headers: {
        Accept: string
        'BrightTALK-API-Client': string
        Cookie?: string
        withCredentials?: boolean
      } = {
        Accept: 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true
        
      }

      const res = await axios.post(`${host}/service/monet/virtualevents-report/generate`, data, { headers })

      dispatch({
        type: actionTypes.EVENTS_REPORT_GENERATION_STARTED,
        payload: { reportId: Number(res?.data?.reportId || null), type }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.EVENTS_REPORT_GENERATED_FAILED, payload: { error: e, type } })

    }

  },

  fetchVirtualEventsReportStatus: (type, reportId, BTSESSION?: string) => async (dispatch, getState) => {

    const eventReportStatus = async () => {

      try {

        const state = getState()
        let host = ''
        
        const headers: {
          Accept: string
          'Content-Type': string
          'BrightTALK-API-Client': string
          Cookie?: string
          withCredentials?: boolean
        } = {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'BrightTALK-API-Client': 'brighttalk-central'
        }

        if (BTSESSION) {

          headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
          host = state.config.host

        } else {

          headers.withCredentials = true
          
        }

        const CancelToken = axios.CancelToken
        const source = CancelToken.source()

        dispatch({ type: actionTypes.SAVE_EVENT_REPORTS_AXIOS_CANCEL_TOKEN, payload: { cancelToken: source, type } })

        const response = await axios.get(`${host}/service/monet/virtualevents-report/status?reportId=${reportId}`, { headers, cancelToken: source.token })

        if (response.data && response.data.length && response.data[response.data.length - 1].status === 'completed') {

          dispatch({
            type: actionTypes.FETCH_EVENTS_REPORT_SUCCESSFUL,
            payload: { reportUrl: response.data[response.data.length - 1].reportUri, reportId, type }
          })

        } else if (response.data && response.data.length && response.data[response.data.length - 1].status === 'failed') {

          dispatch({ type: actionTypes.FETCH_EVENTS_REPORT_FAILED, payload: { error: 'No data found.', type } })

        } else {

          const timeOutId = setTimeout(eventReportStatus, 3000)

          dispatch({
            type: actionTypes.SAVE_EVENT_REPORTS_STATUS_TIMEOUT_ID,
            payload: { timeOutId, type }
          })

        }

      }
      catch (e) {

        if (!axios.isCancel(e)) {
          dispatch({ type: actionTypes.FETCH_EVENTS_REPORT_FAILED, payload: { error: e, type } })
        }

      }

    }

    await eventReportStatus()

  },

  cancelFetchVirtualEventsReport: (type) => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.CANCEL_FETCH_EVENTS_REPORT, payload: { type } })

    try {

      const virtualEventsReport = state.virtualEventsReport[type]

      if(virtualEventsReport && virtualEventsReport.timeOutId) {
        clearTimeout(virtualEventsReport.timeOutId)
      }

      if(virtualEventsReport && virtualEventsReport.cancelToken) {
        virtualEventsReport.cancelToken.cancel()
      }

      dispatch({ type: actionTypes.FETCH_EVENTS_REPORT_CANCELLED, payload: { type } })

    }

    catch (e) {

      dispatch({ type: actionTypes.CANCEL_FETCH_EVENTS_REPORT_FAILED, payload: { type } })

    }

  },

  fetchVirtualEventsStatistics : (eventId: string, BTSESSION?: string) => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.FETCH_VIRTUAL_EVENTS_STATISTICS, payload: {} })

    try {

      const state = getState()
      let host = ''
      
      const headers: {
        Accept: string
        Cookie?: string
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true
        
      }

      const response = await axios.get(`${host}/service/monet/report/summit/${eventId}/statistics`, { headers })

      dispatch({
        type: actionTypes.FETCH_VIRTUAL_EVENTS_STATISTICS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_VIRTUAL_EVENTS_STATISTICS_FAILED, payload: { data: JSON.stringify(e) } })

    }

  },

  fetchEventFeatures : (eventId: string, BTSESSION?: string) => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.FETCH_EVENT_FEATURES, payload: {} })

    try {

      let host = ''

      const headers: {
        Accept: string,
        'Content-Type': string,
        Cookie?: string,
        withCredentials?: boolean
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central',
        withCredentials: true
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.get(`${host}/service/summit/v3/summit/${eventId}/features`, { headers })

      dispatch({
        type: actionTypes.FETCH_EVENT_FEATURES_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      dispatch({ type: actionTypes.FETCH_EVENT_FEATURES_FAILED, payload: { error: JSON.stringify(e) } })

    }

  },

  updateEventFeatures : (eventId: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.UPDATE_EVENT_FEATURES, payload: {} })

    try {

      let host = ''

      const headers: {
        Accept: string,
        'Content-Type': string,
        Cookie?: string,
        withCredentials?: boolean
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central',
        withCredentials: true
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.put(`${host}/service/summit/v3/summit/${eventId}/features`, data, { headers })

      dispatch({
        type: actionTypes.UPDATE_EVENT_FEATURES_SUCCESSFUL,
        payload: { data: response.data }
      })

      return true

    }

    catch (e) {

      dispatch({ type: actionTypes.UPDATE_EVENT_FEATURES_FAILED, payload: { error: JSON.stringify(e) } })

      return false

    }

  },

  fetchCampaignFilter: (accountId: string, campaignId: string, filterType: string, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.FETCH_CAMPAIGN_FILTER })
    const state = getState()

    let host = ''

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      let url = `${host}/service/campaign/account/${accountId}/campaign/${campaignId}/filter?type=${filterType}`
      const { data } = await axios.get( url , {
        headers
      })

      dispatch(({ type: actionTypes.FETCH_CAMPAIGN_FILTER_SUCCESS, payload: data }))

    }
    catch (e) {

      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.FETCH_CAMPAIGN_FILTER_FAILED, payload: errMsg })

    }

  },

  updateCampaignFilter: (accountId: string, campaignId: string, filterType: string, data: any, BTSESSION?: string) => async (dispatch, getState) => {

    dispatch({ type: actionTypes.UPDATE_CAMPAIGN_FILTER })
    const state = getState()

    let host = ''

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      } else {

        headers.withCredentials = true

      }

      let url = `${host}/service/campaign/account/${accountId}/campaign/${campaignId}/filter?type=${filterType}`
      const response = await axios.put( url, data, {headers})

      dispatch(({ type: actionTypes.UPDATE_CAMPAIGN_FILTER_SUCCESS, payload: response.data }))
      dispatch(({ type: actionTypes.FETCH_CAMPAIGN_FILTER_SUCCESS, payload: response.data }))

    }
    catch (e) {

      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.UPDATE_CAMPAIGN_FILTER_FAILED, payload: errMsg })

    }

  },

  resetUpdateCampaignFilterData: () => async(dispatch, getState) => {
    dispatch({type: actionTypes.RESET_UPDATE_CAMPAIGN_FILTER_FAILED})
  },

  getFulfillmentUsersGroup: (BTSESSION: string) => async(dispatch, getState) => {

    dispatch({ type: actionTypes.GET_FULFILLMENT_USERS_GROUP })
    const state = getState()

    let host = ''

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {
        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host
      } else {
        headers.withCredentials = true
      }

      let url = `${host}/service/central/hermes/users`
      const { data } = await axios.get( url , {
        headers
      })

      dispatch(({ type: actionTypes.GET_FULFILLMENT_USERS_GROUP_SUCCESS, payload: data }))

    }
    catch (e) {
      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.GET_FULFILLMENT_USERS_GROUP_FAILED, payload: errMsg })

    }
  },

  getTopics : (phrase = '', BTSESSION?: string) => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.GET_TOPICS, payload: {} })

    try {

      let host = ''

      const headers: {
        Accept: string,
        'Content-Type': string,
        Cookie?: string,
        withCredentials?: boolean
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central',
        withCredentials: true
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.get(`${host}/service/topic/v1/insights/topics?phrase=${phrase}`, { headers })

      dispatch({
        type: actionTypes.GET_TOPICS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.GET_TOPICS_FAILED, payload: { errMsg, phrase: phrase } })

    }

  },

  getTopicsByRank: (BTSESSION: string) => async(dispatch, getState) => {

    dispatch({ type: actionTypes.GET_TOPICS_BY_RANK })
    const state = getState()

    let host = ''

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean 
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {
        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host
      } else {
        headers.withCredentials = true
      }

      let url = `${host}/service/topic/v1/insights/top`
      const { data } = await axios.get( url , { headers })

      dispatch(({ type: actionTypes.GET_TOPICS_BY_RANK_SUCCESS, payload: data }))

    } catch (e) {
      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.GET_TOPICS_BY_RANK_FAILED, payload: errMsg })

    }
  },

  getRelatedTopics: (selectedTopics:string, BTSESSION?: string) => async(dispatch, getState) => {

    dispatch({ type: actionTypes.GET_RELATED_TOPICS })
    const state = getState()

    let host = ''

    try {

      const headers: {
        Accept: string,
        Cookie?: string,
        withCredentials?: boolean 
      } = {
        Accept: 'application/json'
      }

      if (BTSESSION) {
        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host
      } else {
        headers.withCredentials = true
      }

      let url = `${host}/service/topic/v1/insights/relatedtopics?selectedTopics=${selectedTopics}&limit=10`
      const { data } = await axios.get( url , { headers })

      dispatch(({ type: actionTypes.GET_RELATED_TOPICS_SUCCESS, payload: data }))

    } catch (e) {
      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.GET_RELATED_TOPICS_FAILED, payload: errMsg })

    }
  },

  getTopicsInsights : (data: any, BTSESSION?: string) => async (dispatch, getState) => {

    const state = getState()
    dispatch({ type: actionTypes.GET_TOPICS_INSIGHTS, payload: {} })

    try {

      let host = ''

      const headers: {
        Accept: string,
        'Content-Type': string,
        Cookie?: string,
        withCredentials?: boolean
        'BrightTALK-API-Client': string
      } = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'BrightTALK-API-Client': 'brighttalk-central',
        withCredentials: true
      }

      if (BTSESSION) {

        headers.Cookie = 'BTSESSION=' + encodeURIComponent(BTSESSION)
        host = state.config.host

      }

      const response = await axios.post(`${host}/service/topic/v1/insights/insights`, data, { headers })

      dispatch({
        type: actionTypes.GET_TOPICS_INSIGHTS_SUCCESSFUL,
        payload: { data: response.data }
      })

    }

    catch (e) {

      let errMsg = ''

      // @ts-ignore
      if (e.response.data && e.response?.data?.errorCode && e.response?.data?.errorMessage) {
        // @ts-ignore
        errMsg = e.response.data.errorMessage
      }

      dispatch({ type: actionTypes.GET_TOPICS_INSIGHTS_FAILED, payload: { errMsg } })

    }

  },

  clearTopicsInsights: () => async (dispatch, getState) => {

    dispatch({ type: actionTypes.CLEAR_TOPICS_INSIGHTS })

  },

  fetchNurtureAnalytics: (
    channelId: string | number,
    startDate: string,
    endDate: string,
    getNurtureProgramSettings: any,
    fetchProgressTrackerFromApi: any,
    getNurtureUiState: any,
    requestNurtureReportDownloadFromApi
  ) => async (dispatch, getState) => {
    const state = getState()
    const { nurtureAnalytics } = state

    if (nurtureAnalytics?.loading) {
      return
    }

    if (
      nurtureAnalytics?.fetchedStartDate === startDate &&
      nurtureAnalytics?.fetchedEndDate === endDate
    ) {
      return
    }

    dispatch({
      type: actionTypes.FETCH_NURTURE_ANALYTICS,
      payload: { channelId, startDate, endDate }
    })

    try {
      const channelFeatures = state.channelFeatures?.features
      const nurtureSettings = getNurtureProgramSettings(channelFeatures)

      const mapped = await fetchProgressTrackerFromApi(
        channelId,
        startDate,
        endDate
      )

      const uiState = getNurtureUiState({
        nurtureSettings,
        allData: mapped.data,
        windowData: mapped.data,
        enrolledCount: mapped.stats.enrolled,
        thresholdValue: mapped.thresholdValue,
        timeZone: state.currentUser?.currentUser?.timeZone || 'UTC'
      })

      dispatch({
        type: actionTypes.FETCH_NURTURE_ANALYTICS_SUCCESSFUL,
        payload: {
          data: mapped.data,
          stats: mapped.stats,
          uiState,
          startDate,
          endDate
        }
      })
    } catch (e) {
      dispatch({
        type: actionTypes.FETCH_NURTURE_ANALYTICS_FAILED,
        payload: {
          error: JSON.stringify(e),
          uiState: 'DISABLED',
          startDate,
          endDate
        }
      })
    }
  },

  downloadNurtureReport: (
    channelId: string | number,
    startDate: string,
    endDate: string,
    requestNurtureReportDownloadFromApi: any,
    downloadNurtureReportFromStorage: any,
    downloadNurtureReportFile: any,
    getNurtureReportErrorMessage: any
  ) => async (dispatch, getState) => {
    dispatch({
      type: actionTypes.DOWNLOAD_NURTURE_REPORT,
      payload: { channelId, startDate, endDate }
    })

    const state = getState()

    try {
      const reportUri = await requestNurtureReportDownloadFromApi(
        channelId,
        startDate,
        endDate
      )

      if (typeof window !== 'undefined') {
        if (reportUri.startsWith('https://storage.googleapis.com/')) {
          const blob = await downloadNurtureReportFromStorage(reportUri)
          downloadNurtureReportFile(reportUri, channelId, startDate, endDate, blob)
        } else {
          downloadNurtureReportFile(reportUri, channelId, startDate, endDate)
        }
      }

      dispatch({ type: actionTypes.DOWNLOAD_NURTURE_REPORT_SUCCESSFUL })
    } catch (e) {
      dispatch({
        type: actionTypes.DOWNLOAD_NURTURE_REPORT_FAILED,
        payload: { error: getNurtureReportErrorMessage(e) }
      })
    }
  }

}

